/* ── JV Communications Centre — Transplanted from GAS CommsTab.html ── */
/* All bridge calls use window.jvBridge.callAdmin() provided by jv-gas-bridge snippet */

(function() {
  // ── Bridge detection ───────────────────────────────────────────────────────
  var hasBridge = (typeof window.jvBridge !== 'undefined' && typeof window.jvBridge.callAdmin === 'function');

  // ── Cloudflare/D1 read cutover (2026-09-30, GAS-shrink priority, see
  //    state/findings/INCIDENT-gas-degradation-2026-09-30.md) ─────────────────
  // Five of this page's reads (templates / cowork-count / triggers / AI draft
  // queue / approval queue) now have a live D1 mirror behind the relay's
  // 'admin-comms' PROXY_ENTITIES entity (drafts/triggers/templates actions,
  // DEPOLYMENT/cloudflare-cors-relay/worker.js commit 8e9da831a); field
  // shapes verified to match this file's existing render code exactly
  // (template_id/name/channel, draft_id/bride_email/ai_stage/channel,
  // event_name/channel/active, read directly against COMMS_TEMPLATE_COLUMNS_/
  // COMMS_DRAFT_COLUMNS_/COMMS_TRIGGER_COLUMNS_ in jv-crm-mirror/worker.js
  // before wiring, not assumed).
  //
  // The unified timeline ('timeline' action, commit 1099f1d16, points at the
  // SAME /comms-log-history route admin-bride-profile-v6 already uses live)
  // is kept on a SEPARATE flag below, not this one, since its D1 rows are
  // missing two fields the live render code uses (open_count for the
  // email-opened badge, gmail_thread_id for the Open-in-Gmail/Sync-Thread/
  // triage-select row actions; confirmed by reading handleCommsLogHistoryRead's
  // own mapping, the comms_log mirror writer doesn't capture either). Flipping
  // the timeline flag is a real feature trade, not just a transport swap, so
  // do not flip it without Jess/Consolidator sign-off on losing those two
  // pieces of UI until CommsLogMirrorSync_2026_08_29.gs is extended to
  // capture them (a separate, later piece of work).
  //
  // BOTH flags default false, same "committed but held" discipline as
  // COMMS_D1_SEARCH_ENABLED_ below. Do not flip either until ALL of:
  //   1. GAS-side CommsMirrorSync_2026_09_19.gs has been armed and run once
  //      (JV_commsMirror_enable() then JV_commsMirror_pushNow()) so
  //      comms_drafts/comms_triggers/comms_templates hold real rows, not
  //      correctly-shaped-but-empty ones (confirmed empty by Cloudflare/Edge
  //      2026-09-30, the write-side sync has never been turned on).
  //   2. COMMS_DRAFTS_MIRROR_ENABLED / COMMS_TRIGGERS_MIRROR_ENABLED /
  //      COMMS_TEMPLATES_MIRROR_ENABLED are armed in DEPOLYMENT/jv-crm-mirror
  //      /wrangler.toml (not present as of this commit, the GET routes
  //      404 with *_mirror_disabled until then).
  //   3. jv-crm-mirror grows a POST-shaped shim for /comms-drafts,
  //      /comms-triggers, /comms-templates, confirmed by direct read
  //      (worker.js:10960-10978) that these 3 routes are GET-method-only,
  //      while the relay's handlePartnerProxyEntity_ always forwards as
  //      POST (unconditionally, every entity). Only /comms-log-history has
  //      a POST-shim reconstruction (worker.js near line 11451, built for
  //      admin-bride-profile-v6's 'comms' action); 'drafts'/'triggers'/
  //      'templates' will 404/fail against the live routes as they stand
  //      today, even once flag #2 above is armed. This is Cloudflare/Edge's
  //      file (jv-crm-mirror/worker.js), flagged back to them, not
  //      something this file can fix.
  //   4. The 'admin-comms' relay entity itself is deployed (committed on
  //      Cloudflare/Edge's branch as of this commit, not yet merged/live).
  //   5. A real jfg-identity end-to-end test against each wired call
  //      passes, same discipline as COMMS_D1_SEARCH_ENABLED_ below.
  var COMMS_D1_READS_ENABLED_ = false;
  var COMMS_D1_TIMELINE_ENABLED_ = false;

  // Comms lane Slice 3 (2026-10-15, BRIEFS/SCOPE-comms-cf-integration-
  // 2026-10-15.md), Jess's direct greenlight -- 100% off GAS is the goal,
  // so this read gets its OWN flag rather than waiting for
  // COMMS_D1_READS_ENABLED_ (which still gates 5 other reads that are NOT
  // ready: jv-crm-mirror's /comms-templates, /comms-triggers, /comms-drafts
  // routes are GET-method-only today, confirmed by reading worker-
  // router.mjs directly, and the relay's handlePartnerProxyEntity_ always
  // forwards as POST -- a POST-shim like the one /comms-log-history already
  // has is owed before ANY of those 5 can safely go live. See
  // BRIEFS/HANDOFF-comms-slice3-worker-postshim-2026-10-15.md). Templates is
  // the one read this slice closes the loop on end-to-end -- the POST-shim
  // AND the frontend repoint both land in this same change, so this flag
  // (unlike the umbrella one) is safe to flip the moment the Worker side
  // ships and D1 is warm (JV_commsMirror_enable + JV_commsMirror_pushNow,
  // Jess running these separately per her own Q2 answer).
  var COMMS_D1_READS_TEMPLATES_ENABLED_ = false;

  // Comms lane Slice 4 (2026-10-15, same brief, next read after templates).
  // Picked the pending-cowork-count badge as the lowest-risk of the 4
  // remaining candidate reads (single number, read-only, no complex render)
  // -- same reasoning templates used over the other reads in Slice 3.
  // Routes through the 'drafts' action with {view:'cowork_count'}, so it
  // is STILL BLOCKED on the SAME owed Worker POST-shim as triggers/drafts
  // (`/comms-drafts` is GET-only today) -- see
  // BRIEFS/HANDOFF-comms-slice3-worker-postshim-2026-10-15.md, section 3's
  // `view` param note. Do NOT flip this flag until that shim ships AND the
  // `comms_drafts` D1 table is confirmed warm for cowork-count rows
  // specifically (the 2026-10-15 pushNow run populated templates (41) and
  // drafts (3) -- confirm those 3 drafts include at least one cowork-queue
  // row, or this read will correctly return an empty badge against a
  // technically-working route, which could read as a false "zero pending"
  // during testing).
  var COMMS_D1_READS_COWORKCOUNT_ENABLED_ = false;

  // Comms lane Slice 5 (2026-10-15, same brief). Approval queue -- biggest
  // value of the remaining reads (the primary comms-queue view), unblocked
  // by the Worker POST-shim (commit 688441972, same `view: 'approval_queue'`
  // action on the now-POST-reachable /comms-drafts route). Covers BOTH real
  // call sites that read this view: commsQueueLoad (full queue render) and
  // commsQueueRefreshBadge (lightweight tab-badge count) -- one flag, two
  // call sites, same as how templates/cowork-count each got their own
  // dedicated flag rather than reusing the umbrella one.
  var COMMS_D1_READS_APPROVALQUEUE_ENABLED_ = false;

  // Comms lane Slice 6 (2026-10-15, same brief). AI-draft queue -- the 5th
  // and penultimate of the 6 reads this lane named; unblocked by the same
  // Worker POST-shim (commit 688441972) as Slice 5. Triggers (the 6th and
  // last read) stays untouched -- blocked on the separate skippedRows:34
  // mystery, which is someone else's lane to trace, not a transport gap
  // this slice's shape would fix.
  var COMMS_D1_READS_AIQUEUE_ENABLED_ = false;

  // Comms lane Slice 2 (2026-10-15, BRIEFS/SCOPE-comms-cf-integration-
  // 2026-10-15.md). CF-first write for the trigger auto-send toggle and the
  // AI-draft approve/reject actions, via the relay-proxy entity Slice 1
  // added ('trigger-toggle'/'draft-stage' actions on 'admin-comms', commit
  // 00b6ee243 -- the Worker-side outbox write routes themselves predate
  // this file's involvement). GAS stays the fallback on any CF failure,
  // same shape as every other CF-first/GAS-fallback port on this theme
  // (jv-team-dashboard.js's loadDashboardCrmMirror_, jv-abp-v6.js's
  // partyBreakdownConfirmD1_).
  //
  // DO NOT FLIP TO true UNTIL ALL OF:
  //   1. The relay-proxy entity (Slice 1) is confirmed LIVE, not just
  //      committed -- same "committed but held" trap every flag on this
  //      theme has to respect.
  //   2. The GAS-side outbox DRAINS are armed:
  //      JV_COMMS_TRIGGER_TOGGLE_OUTBOX_DRAIN_ENABLED AND
  //      JV_COMMS_DRAFT_STAGE_OUTBOX_DRAIN_ENABLED (both script properties
  //      in COMMS.gs, both default OFF, confirmed by reading the file
  //      directly 2026-10-15). WITHOUT THIS, a write through this path
  //      writes a real row to the D1 outbox and returns ok:true -- the UI
  //      shows success -- but NOTHING EVER DRAINS IT to the COMMS_TRIGGERS/
  //      COMMS_DRAFTS sheets GAS actually reads. A trigger toggle silently
  //      never takes effect; an approved draft silently never reaches
  //      comms_processPendingApprovedDrafts_'s hourly sweep (which reads the
  //      SHEET, not this outbox) and so NEVER auto-sends. This fails in the
  //      SAFE direction for the P0.8 hard-review-gate (nothing unapproved
  //      goes out -- see memory feedback_no_unapproved_comms), but it is
  //      still a real "looks like it worked, did nothing" bug, the same
  //      class this lane's own party-breakdown slice had to reconcile.
  //   3. Per the Oct-1 audit (BRIEFS/SCOPE-comms-cf-integration-2026-10-15.md
  //      open question #3, still unanswered as of this commit): the GAS
  //      drain has NO recurring cron by deliberate standing architectural
  //      decision (REBUILD-CLOUDFLARE/wrangler.pilot.toml's own comment) --
  //      "armed" above means a human runs the drain functions from the IDE
  //      periodically, not that this becomes real-time once flipped. Do not
  //      flip this flag expecting auto-resolution within minutes.
  // Until all three are true, this flag stays false and every call below
  // takes the GAS path exactly as it always has -- byte-identical
  // behaviour, nothing dark activates.
  var COMMS_D1_WRITE_OUTBOX_ENABLED_ = false;

  // Idempotency key for an outbox write -- same recipe as jvD1Key_ in
  // jv-abp-v6.js (timestamp + random suffix), without a bride-uid prefix
  // since these two actions are admin-global, not bride-scoped.
  function commsIdemKey_(kind) {
    return kind + '|' + Date.now() + '|' + Math.random().toString(36).slice(2);
  }

  // Mirrors jvInvProxyCall_ in assets/jv-abp-v6.js, same signed relay proxy
  // pattern (POST /partner/<entity>/<action>, secret injected relay-side),
  // NOT a bare fetch with a query-string secret (that pattern was a P0
  // exposure closed 2026-09-23, see that file's own header comment). This
  // file already sets window._jvAdminProxyBase (sections/jv-comms.liquid,
  // "Shared proxy base" comment, 2026-09-25) for the existing D1 bride
  // search switch below, reused here rather than duplicated.
  function commsD1ProxyCall_(action, body) {
    var base = window._jvAdminProxyBase;
    if (!base) return Promise.resolve({ ok: false, error: 'proxy_unavailable' });
    var url = String(base).replace(/\/+$/, '') + '/partner/admin-comms/' + action;
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    return nf(url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(body || {})
    }).then(function(r) { return r.json(); }).catch(function() {
      return { ok: false, error: 'network_error' };
    });
  }

  // ── Helpers ────────────────────────────────────────────────────────────────

  function commsPanelRoot() {
    return document.getElementById('comms-panel');
  }

  function commsBrideEmail() {
    return commsPanelRoot().getAttribute('data-bride-email') || '';
  }

  function commsShowStatus(elId, type, msg) {
    var el = document.getElementById(elId);
    if (!el) return;
    el.className = 'comms-status ' + type;
    el.textContent = msg;
  }

  function commsHideStatus(elId) {
    var el = document.getElementById(elId);
    if (!el) return;
    el.className = 'comms-status';
    el.textContent = '';
  }

  function commsFormatDate(ts) {
    if (!ts) return '\u2014';
    var d = new Date(ts);
    if (isNaN(d)) return String(ts).substring(0, 16);
    var pad = function(n) { return String(n).padStart(2, '0'); };
    return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear()
      + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
  }

  // ── Tab switching ──────────────────────────────────────────────────────────

  var COMMS_TAB_IDS = ['timeline', 'compose', 'templates', 'automations', 'ai', 'queue'];
  var COMMS_TAB_LABEL_MAP = {
    'timeline': 'time', 'compose': 'comp', 'templates': 'temp',
    'automations': 'auto', 'ai': 'ai a', 'queue': 'queu'
  };

  window.commsShowTab = function(tab) {
    document.querySelectorAll('#comms-panel .comms-tab-btn').forEach(function(btn) {
      var label = btn.textContent.trim().toLowerCase();
      var match = COMMS_TAB_LABEL_MAP[tab] || tab.substring(0, 4);
      btn.classList.toggle('active', label.indexOf(match) !== -1);
    });
    COMMS_TAB_IDS.forEach(function(t) {
      var pane = document.getElementById('comms-pane-' + t);
      if (pane) pane.classList.toggle('active', t === tab);
    });
    if (tab === 'compose') {
      var toField = document.getElementById('comms-compose-to');
      if (toField) toField.value = commsBrideEmail();
      commsUpdateQuietHoursBanner();
    }
    if (tab === 'templates') {
      commsTplLoad();
    }
    if (tab === 'automations') {
      commsAutoLoad();
    }
    if (tab === 'ai') {
      commsAiCheckStakes();
      commsAiLoadQueue();
    }
    if (tab === 'queue') {
      commsQueueLoad();
    }
  };

  // ── Quiet hours notice ───────────────────────────────────────────────────────
  // Mirrors the business rule: no automated bride-facing sends 20:00-08:00 Sydney.
  // Computed client-side (pure time check, no bridge call). Shows a heads-up so
  // Jess knows a night-time send will queue rather than go out immediately.
  function commsIsQuietHoursSydney() {
    try {
      var h = parseInt(new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Sydney', hour: '2-digit', hour12: false
      }).format(new Date()), 10);
      if (isNaN(h)) return false;
      return (h >= 20 || h < 8);
    } catch (e) { return false; }
  }

  function commsUpdateQuietHoursBanner() {
    var el = document.getElementById('comms-quiet-hours-banner');
    if (!el) return;
    el.style.display = commsIsQuietHoursSydney() ? 'block' : 'none';
  }
  window.commsUpdateQuietHoursBanner = commsUpdateQuietHoursBanner;

  // ── Timeline load ──────────────────────────────────────────────────────────

  // PAGING (2026-08-04, BRIEFS/BUILD-comms-timeline-paging-2026-08-04.md):
  // measured live at 21-26s / 137KB against a 30s Cloudflare relay ceiling --
  // roughly 4s from failing outright for every bride. The old code always
  // requested { limit: 200 } (silently ignored by the live bridge -- see
  // below -- so the model's own default of limit:100 was what actually ran).
  // Default page size is now 30, newest-first (server already sorts
  // newest-first), with an explicit "Load older" button injected below the
  // list so nothing looks silently missing.
  //
  // IMPORTANT bridge constraint (documented, not routed around): the live
  // bridge handler shopifyBridge_commsGetUnifiedTimeline() in ShopifyBridge.gs
  // only forwards two top-level payload keys into the model call --
  // payload.maxRows and payload.includeMetadata. It does NOT forward
  // payload.options (limit/offset/withMeta), which is what this frontend used
  // to send and which the bridge silently dropped. ShopifyBridge.gs is owned
  // by another in-flight session and was locked at the time of this fix, so
  // this file sends paging params using the NAMES THE LIVE BRIDGE ACTUALLY
  // FORWARDS (maxRows, includeMetadata) rather than a real offset cursor
  // (which the live bridge drops entirely today). "Load older" therefore
  // re-requests with a larger maxRows rather than paging by offset -- honest
  // and working today, and will start behaving like true offset paging for
  // free once ShopifyBridge.gs forwards payload.options
  // (comms_getUnifiedTimeline_ in CommsUnifiedModel.gs already supports both
  // offset and the maxRows/includeMetadata alias names).
  var COMMS_TIMELINE_PAGE_SIZE = 30;
  var _commsTimelineMaxRows = COMMS_TIMELINE_PAGE_SIZE; // grows on "Load older"
  var _commsTimelineHasMore = false;
  var _commsTimelineTotal = 0;

  function commsUnwrapTimelineResult_(result) {
    var payload = (result && result.data) || result;
    if (Array.isArray(payload)) return { rows: payload, hasMore: false, total: payload.length };
    if (payload && Array.isArray(payload.rows)) {
      return {
        rows: payload.rows,
        hasMore: !!payload.hasMore,
        total: (typeof payload.total === 'number') ? payload.total : payload.rows.length
      };
    }
    if (Array.isArray(result)) return { rows: result, hasMore: false, total: result.length };
    return { rows: [], hasMore: false, total: 0 };
  }

  // Injected as a SIBLING after #comms-timeline (never inside it) because
  // commsRenderTimeline() below does list.innerHTML = '' on every render --
  // anything placed inside #comms-timeline would be wiped on each repaint.
  function commsEnsureLoadOlderButton_() {
    var btn = document.getElementById('comms-timeline-load-older');
    if (btn) return btn;
    var list = document.getElementById('comms-timeline');
    if (!list || !list.parentNode) return null;
    btn = document.createElement('button');
    btn.id = 'comms-timeline-load-older';
    btn.type = 'button';
    btn.className = 'comms-btn comms-btn-ghost';
    btn.style.display = 'none';
    btn.style.marginTop = '12px';
    btn.textContent = 'Load older messages';
    btn.onclick = function() { window.commsLoadOlderTimeline(); };
    list.parentNode.insertBefore(btn, list.nextSibling);
    return btn;
  }

  function commsUpdateLoadOlderButton_() {
    var btn = commsEnsureLoadOlderButton_();
    if (!btn) return;
    btn.style.display = _commsTimelineHasMore ? '' : 'none';
  }

  // (2026-07-19, WS-3 perf fix) Paint the unified timeline FIRST from
  // comms_getUnifiedTimeline (a single-sheet scan, fast once warm), instead of
  // chaining gmail_syncThreads before it. gmail_syncThreads_ does a full
  // GmailApp.search() plus per-thread/per-message loop plus its own
  // comms-sheet re-read, a second full GAS cold-start round trip stacked
  // serially behind the first, confirmed (not guessed) as the actual ~30s
  // cause, not comms_getUnifiedTimeline_ itself (which has its own permanent
  // timing instrumentation as of this same date, see CommsUnifiedModel.gs).
  // The Gmail sync now runs in the BACKGROUND after first paint, and only
  // triggers a re-render if it reports synced > 0 new messages (so a quiet
  // inbox never repaints an already-correct timeline).
  // Single place that knows whether the timeline read goes to D1 or GAS,
  // reused by every one of the 4 call sites below (initial load, load-older,
  // quiet refresh, post-Gmail-sync refresh) so the flag/route choice can
  // never drift between them. D1 route uses real limit/offset; GAS uses the
  // maxRows-widening pattern (see PAGING comment above) -- mapping maxRows
  // straight to limit here is an approximation, acceptable because
  // COMMS_D1_TIMELINE_ENABLED_ defaults false (see the flag's own header
  // comment for the full held-back checklist).
  function commsFetchTimeline_(brideEmail, maxRows) {
    if (COMMS_D1_TIMELINE_ENABLED_) {
      return commsD1ProxyCall_('timeline', { brideEmail: brideEmail, limit: maxRows });
    }
    return jvBridge.callAdmin('comms_getUnifiedTimeline', {
      brideEmail: brideEmail, maxRows: maxRows, includeMetadata: true
    });
  }

  function commsBackgroundSyncGmail_(brideEmail) {
    jvBridge.callAdmin('gmail_syncThreads', { email: brideEmail, options: {} })
      .then(function(result) {
        var payload = (result && result.data) || result;
        var synced = (payload && payload.synced) || 0;
        if (!synced) return; // nothing new -- keep the already-painted timeline
        return commsFetchTimeline_(brideEmail, _commsTimelineMaxRows).then(function(freshResult) {
          var unwrapped = commsUnwrapTimelineResult_(freshResult);
          _commsTimelineRows = unwrapped.rows;
          _commsTimelineHasMore = unwrapped.hasMore;
          _commsTimelineTotal = unwrapped.total;
          commsRenderTimeline(_commsTimelineRows);
          commsUpdateLoadOlderButton_();
          commsLoadTriageSummary();
        });
      })
      .catch(function() { /* background sync is best-effort -- keep the painted timeline on failure */ });
  }

  window.commsLoadTimeline = function() {
    var brideEmail = commsBrideEmail();
    if (!brideEmail) {
      commsShowStatus('comms-timeline', 'error', 'No bride email set on panel.');
      return;
    }
    var loading = document.getElementById('comms-timeline-loading');
    var list = document.getElementById('comms-timeline');
    loading.classList.add('visible');
    list.innerHTML = '';
    _commsTimelineMaxRows = COMMS_TIMELINE_PAGE_SIZE;

    // Load the unified timeline (all channels) FIRST, paint immediately.
    // Page size defaults to 30 (was effectively 100-200) -- see PAGING
    // comment above for why. NOTE: Bridge wraps comms_getUnifiedTimeline to
    // { ok, data: [rows] } since the handler returns a flat array (or, with
    // includeMetadata, { rows, total, hasMore, nextOffset }). The unwrap
    // helper accepts either shape plus the legacy bare-array shape.
    commsFetchTimeline_(brideEmail, _commsTimelineMaxRows)
      .then(function(result) {
        loading.classList.remove('visible');
        var unwrapped = commsUnwrapTimelineResult_(result);
        _commsTimelineRows = unwrapped.rows;
        _commsTimelineHasMore = unwrapped.hasMore;
        _commsTimelineTotal = unwrapped.total;
        commsRenderTimeline(_commsTimelineRows);
        commsUpdateLoadOlderButton_();
        commsLoadTriageSummary();
        // Background Gmail sync AFTER first paint -- only re-renders if it
        // finds genuinely new messages (synced > 0).
        commsBackgroundSyncGmail_(brideEmail);
      })
      .catch(function(err) {
        loading.classList.remove('visible');
        list.innerHTML = '<div class="comms-empty" style="color:#c0392b;">Error loading timeline: ' + (err.message || err) + '</div>';
      });
  };

  // "Load older" -- widens the requested page (see PAGING comment above for
  // why this grows maxRows rather than using a true offset cursor) and
  // re-renders. Never truncates silently: the button only shows when the
  // server reported hasMore (via includeMetadata), and _commsTimelineTotal
  // is tracked for a future "showing X of Y" label if wanted.
  window.commsLoadOlderTimeline = function() {
    var brideEmail = commsBrideEmail();
    if (!brideEmail) return;
    var btn = document.getElementById('comms-timeline-load-older');
    if (btn) { btn.disabled = true; btn.textContent = 'Loading...'; }
    _commsTimelineMaxRows += COMMS_TIMELINE_PAGE_SIZE;
    commsFetchTimeline_(brideEmail, _commsTimelineMaxRows)
      .then(function(result) {
        var unwrapped = commsUnwrapTimelineResult_(result);
        _commsTimelineRows = unwrapped.rows;
        _commsTimelineHasMore = unwrapped.hasMore;
        _commsTimelineTotal = unwrapped.total;
        commsRenderTimeline(_commsTimelineRows);
        commsUpdateLoadOlderButton_();
      })
      .catch(function(err) {
        commsShowStatus('comms-timeline', 'error', 'Could not load older messages: ' + (err.message || err));
      })
      .then(function() {
        if (btn) { btn.disabled = false; btn.textContent = 'Load older messages'; }
      });
  };

  // (2026-07-19, WS-3 perf fix) Refetches the timeline WITHOUT the loading
  // spinner or clearing the list first, so a single-thread sync (commsSyncThread
  // below) doesn't drop the whole panel to a blank "Loading..." state, the
  // already-rendered timeline stays on screen until the fresh rows are ready.
  // Keeps whatever page width (maxRows) is already loaded rather than
  // resetting to the first page.
  function commsRefreshTimelineQuiet_(brideEmail) {
    return commsFetchTimeline_(brideEmail, _commsTimelineMaxRows)
      .then(function(result) {
        var unwrapped = commsUnwrapTimelineResult_(result);
        _commsTimelineRows = unwrapped.rows;
        _commsTimelineHasMore = unwrapped.hasMore;
        _commsTimelineTotal = unwrapped.total;
        commsRenderTimeline(_commsTimelineRows);
        commsUpdateLoadOlderButton_();
        commsLoadTriageSummary();
      });
  }

  var COMMS_CHANNEL_LABELS = {
    'EMAIL': 'Email', 'SMS': 'SMS', 'INSTAGRAM_DM': 'IG DM',
    'FACEBOOK_DM': 'FB DM', 'PUSH': 'Push', 'NOTIFY': 'Push',
    'MANUAL': 'Manual', 'SYSTEM': 'System'
  };

  function commsRenderTimeline(rows, isFiltered) {
    var list = document.getElementById('comms-timeline');
    if (!rows || rows.length === 0) {
      var msg = isFiltered ? 'No messages match the current filters.' : 'No communications found for this bride.';
      list.innerHTML = '<div class="comms-empty">' + msg + '</div>';
      return;
    }

    list.innerHTML = '';
    rows.forEach(function(row, idx) {
      var channel = (row.channel || 'MANUAL').toUpperCase();
      var direction = (row.direction || '').toUpperCase();
      var dirArrow = direction === 'OUTBOUND' ? '\u2191' : '\u2193';
      var dirClass = direction === 'OUTBOUND' ? 'comms-dir-out' : 'comms-dir-in';
      var knownChannels = ['EMAIL','SMS','INSTAGRAM_DM','FACEBOOK_DM','PUSH','NOTIFY','MANUAL','SYSTEM'];
      var badgeClass = 'comms-badge-' + (knownChannels.indexOf(channel) !== -1 ? channel : 'SYSTEM');
      var subject = row.subject || row.body_snippet || '(no subject)';
      var body = row.body_full || row.body_snippet || '';

      // Task 14: triage badge for email rows
      var triageBadge = '';
      var triageStatus = (row.status || '').toUpperCase();
      if (channel === 'EMAIL' && ['NEEDS_REPLY','FOLLOW_UP','WAITING','URGENT','ACTIONED'].indexOf(triageStatus) !== -1) {
        triageBadge = '<span class="comms-badge-triage comms-badge-' + triageStatus + '">' + triageStatus.replace(/_/g, ' ') + '</span>';
      }

      // Task 37: email open tracking badge for outbound emails
      var openBadge = '';
      if (channel === 'EMAIL' && direction === 'OUTBOUND') {
        var openCount = parseInt(row.open_count, 10) || 0;
        if (openCount > 0) {
          openBadge = '<span class="comms-badge comms-badge-opened">' +
            (openCount > 1 ? 'Opened ' + openCount + 'x' : 'Opened') + '</span>';
        } else {
          openBadge = '<span class="comms-badge comms-badge-not-opened">Not yet opened</span>';
        }
      }

      // Task 14: Gmail thread actions for EMAIL rows
      var threadActions = '';
      if (channel === 'EMAIL' && row.gmail_thread_id) {
        var tid = commsEscape(row.gmail_thread_id);
        threadActions =
          '<div class="comms-row-actions">' +
            '<button class="comms-btn comms-btn-ghost" onclick="event.stopPropagation();commsOpenThread(\'' + tid + '\')">Open in Gmail</button>' +
            '<button class="comms-btn comms-btn-ghost" onclick="event.stopPropagation();commsSyncThread(\'' + tid + '\')">Sync Thread</button>' +
            '<select class="comms-triage-select" onclick="event.stopPropagation()" onchange="commsSetTriageFromRow(\'' + tid + '\', this)">' +
              '<option value="">Set Triage...</option>' +
              '<option value="NEEDS_REPLY">Needs Reply</option>' +
              '<option value="FOLLOW_UP">Follow Up</option>' +
              '<option value="WAITING">Waiting on Bride</option>' +
              '<option value="URGENT">Urgent</option>' +
              '<option value="ACTIONED">Actioned</option>' +
            '</select>' +
          '</div>';
      }

      var item = document.createElement('div');
      item.className = 'comms-row';
      item.innerHTML =
        '<div class="comms-row-header" onclick="commsToggleRow(this)">' +
          '<span class="comms-date-pill">' + commsFormatDate(row.timestamp) + '</span>' +
          '<span class="comms-badge ' + badgeClass + '">' + (COMMS_CHANNEL_LABELS[channel] || channel) + '</span>' +
          triageBadge +
          openBadge +
          '<span class="comms-direction ' + dirClass + '">' + dirArrow + '</span>' +
          '<span class="comms-subject">' + commsEscape(subject) + '</span>' +
          '<span class="comms-chevron">\u25BC</span>' +
        '</div>' +
        '<div class="comms-row-body">' + commsEscape(body || '(no body)') + '</div>' +
        threadActions;

      list.appendChild(item);
    });
  }

  window.commsToggleRow = function(headerEl) {
    var row = headerEl.closest('.comms-row');
    if (row) row.classList.toggle('expanded');
  };

  // ── Manual entry form ──────────────────────────────────────────────────────

  window.commsToggleManualForm = function() {
    var form = document.getElementById('comms-manual-form');
    form.classList.toggle('open');
    if (form.classList.contains('open')) {
      commsHideStatus('comms-manual-status');
    }
  };

  window.commsSaveManualEntry = function() {
    var brideEmail = commsBrideEmail();
    var channel   = document.getElementById('comms-manual-channel').value;
    var direction = document.getElementById('comms-manual-direction').value;
    var subject   = document.getElementById('comms-manual-subject').value.trim();
    var body      = document.getElementById('comms-manual-body').value.trim();

    if (!brideEmail) {
      commsShowStatus('comms-manual-status', 'error', 'No bride email set on panel.');
      return;
    }
    if (!subject) {
      commsShowStatus('comms-manual-status', 'error', 'Subject / Label is required.');
      return;
    }

    commsShowStatus('comms-manual-status', 'info', 'Saving...');

    jvBridge.callAdmin('comms_logManualEntry', { brideEmail: brideEmail, channel: channel, direction: direction, subject: subject, body: body, extra: '' })
      .then(function() {
        commsShowStatus('comms-manual-status', 'success', 'Entry saved.');
        document.getElementById('comms-manual-subject').value = '';
        document.getElementById('comms-manual-body').value = '';
        setTimeout(function() {
          document.getElementById('comms-manual-form').classList.remove('open');
          commsHideStatus('comms-manual-status');
          commsLoadTimeline();
        }, 1200);
      })
      .catch(function(err) {
        commsShowStatus('comms-manual-status', 'error', 'Error: ' + (err.message || err));
      });
  };

  // ── Compose / Send email ───────────────────────────────────────────────────

  window.commsSendEmail = function() {
    var brideEmail = commsBrideEmail();
    var subject = document.getElementById('comms-compose-subject').value.trim();
    var body    = document.getElementById('comms-compose-body').value.trim();

    if (!brideEmail) {
      commsShowStatus('comms-compose-status', 'error', 'No bride email set on panel.');
      return;
    }
    if (!subject) {
      commsShowStatus('comms-compose-status', 'error', 'Subject is required.');
      return;
    }
    if (!body) {
      commsShowStatus('comms-compose-status', 'error', 'Body is required.');
      return;
    }

    var alsoSmsEl   = document.getElementById('comms-compose-also-sms');
    var alsoSms     = alsoSmsEl && alsoSmsEl.checked;
    var smsBodyEl   = document.getElementById('comms-compose-sms-body');
    var smsBody     = smsBodyEl ? smsBodyEl.value.trim() : '';
    var bridePhone  = commsPanelRoot().getAttribute('data-bride-phone') || '';

    commsShowStatus('comms-compose-status', 'info', 'Sending...');

    var route   = (alsoSms && bridePhone && smsBody) ? 'comms_sendEmailAndSms' : 'comms_sendEmail';
    var payload = { brideEmail: brideEmail, subject: subject, body: body, extra: '' };
    if (route === 'comms_sendEmailAndSms') {
      payload.phone   = bridePhone;
      payload.smsBody = smsBody;
    }

    jvBridge.callAdmin(route, payload)
      .then(function(result) {
        // P0.6 (2026-06-04): show "sent" ONLY when something actually went. Honest
        // status for safe-mode block (doPost or sender), quiet-hours defer, rate limit.
        if (result && result.blocked === 'safe_mode') {
          commsShowStatus('comms-compose-status', 'error', 'Blocked -- safe mode is active. Nothing was sent.');
          return;
        }
        var st = (result && result.status) ? String(result.status).toLowerCase() : (result && result.ok ? 'sent' : '');
        if (st === 'deferred' || st === 'blocked_quiet_hours') {
          commsShowStatus('comms-compose-status', 'info', 'Deferred, outside contact hours. It will send after 8am Sydney.');
          return;
        }
        if (st === 'blocked' || st === 'blocked_safe_mode') {
          commsShowStatus('comms-compose-status', 'error', 'Blocked -- safe mode is active. Nothing was sent.');
          return;
        }
        if (st === 'rate_limited') {
          commsShowStatus('comms-compose-status', 'error', 'Not sent -- daily message limit for this bride reached.');
          return;
        }
        if (st !== 'sent' && st !== 'queued') {
          commsShowStatus('comms-compose-status', 'error', 'Could not confirm the message was sent.');
          return;
        }
        var msg = 'Email sent successfully.';
        if (route === 'comms_sendEmailAndSms') msg = 'Email + SMS sent successfully.';
        commsShowStatus('comms-compose-status', 'success', msg);
        document.getElementById('comms-compose-subject').value = '';
        document.getElementById('comms-compose-body').value = '';
        if (smsBodyEl) smsBodyEl.value = '';
        if (alsoSmsEl) {
          alsoSmsEl.checked = false;
          var smsBox = document.getElementById('comms-compose-sms-box');
          if (smsBox) smsBox.style.display = 'none';
        }
        setTimeout(function() {
          commsHideStatus('comms-compose-status');
          commsShowTab('timeline');
          commsLoadTimeline();
        }, 1500);
      })
      .catch(function(err) {
        commsShowStatus('comms-compose-status', 'error', 'Error: ' + (err.message || err));
      });
  };

  // ── XSS-safe text escape ───────────────────────────────────────────────────

  function commsEscape(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Phase 3: Channel toggle ────────────────────────────────────────────────

  window.commsSelectChannel = function(ch) {
    document.getElementById('comms-email-compose').style.display = ch === 'email' ? '' : 'none';
    document.getElementById('comms-sms-compose').style.display   = ch === 'sms'   ? '' : 'none';
    document.getElementById('comms-ig-compose').style.display    = ch === 'ig_dm' ? '' : 'none';
    document.getElementById('comms-fb-compose').style.display    = ch === 'fb_dm' ? '' : 'none';
    document.getElementById('comms-ch-email-btn').classList.toggle('active', ch === 'email');
    document.getElementById('comms-ch-sms-btn').classList.toggle('active',   ch === 'sms');
    document.getElementById('comms-ch-ig-btn').classList.toggle('active',    ch === 'ig_dm');
    document.getElementById('comms-ch-fb-btn').classList.toggle('active',    ch === 'fb_dm');

    // Pre-fill Meta DM recipient IDs from social links
    if (ch === 'ig_dm' || ch === 'fb_dm') {
      commsLoadMetaRecipient(ch);
    }
  };

  // ── Phase 3: SMS char counter ──────────────────────────────────────────────

  window.commsUpdateSmsCharCount = function() {
    var len  = (document.getElementById('comms-sms-body').value || '').length;
    var msgs = Math.ceil(len / 160) || 1;
    var el   = document.getElementById('comms-sms-char-count');
    el.textContent = len + ' / ' + (msgs * 160) + ' (' + msgs + ' msg' + (msgs > 1 ? 's' : '') + ')';
    el.classList.toggle('over', len > 160);
  };

  // ── Phase 3: Open in Shortcuts ─────────────────────────────────────────────
  //
  // MOVED TO PURE FRONTEND (2026-09-23, Wave E of the Comms lane's GAS-exit
  // migration, state/findings/SCOPE-comms-wave-e-sends-2026-09-23.md). The
  // GAS function this UI actually called, comms_buildSmsShortcutUrl_
  // (CommsAPI.gs), was a pure function with no side effects -- it normalised
  // a phone number and built a shortcuts:// deep-link string, nothing more.
  // Building that string client-side removes a network round-trip for zero
  // loss of behaviour: a URL builder has nothing to gate, nothing to log,
  // nothing that needs GAS's Sheets access.
  //
  // TWO REAL FINDINGS from tracing this, not just porting the code as-is:
  //
  // 1. THE OLD RESPONSE-SHAPE BUG. This UI checked `res.safe_mode`, but the
  //    route it actually called never returned that shape -- it returned
  //    `{ok:true, data:null}` on safe mode (the bridge wraps a bare `null`
  //    return under `data`), so `res.safe_mode` was always undefined and the
  //    warning banner could never have fired. Worse, after jvUnwrap `res`
  //    itself could be `null`, and `res.safe_mode` on a null `res` throws a
  //    TypeError inside the resolved .then() -- uncaught by the .catch()
  //    below it, since the error happens on the success path, not the
  //    rejection path. Fixed by construction: there is no safe-mode branch
  //    to get wrong now, because link-building was never something safe mode
  //    needed to suppress in the first place.
  //
  // 2. A BETTER, UNUSED VERSION ALREADY EXISTED IN GAS. comms_smsValidatePhone_
  //    + comms_buildSmsShortcutUrlV2_ (CommsSms.gs) is a hardened rewrite of
  //    the same builder -- real phone-format validation with a clear error
  //    message, and an em-dash strip via JV_lintCopy before encoding into the
  //    URL. It was wired to its own route (comms_sms_build_url_v2,
  //    CommsAPI.gs:768) but that route has ZERO frontend callers anywhere --
  //    this UI kept calling the older, buggier comms_buildSmsShortcutUrl all
  //    along. This port brings the V2 validation logic across (worth keeping,
  //    genuinely better), NOT the em-dash strip -- JV_lintCopy's real
  //    behaviour (read from source, not from memory) treats 'sms' the SAME
  //    as 'email': hard block, auto-clean, AND fire an admin Chat alert on a
  //    violation. A pure frontend function cannot fire that alert without
  //    reintroducing the network call this move is removing, so the alerting
  //    side-effect is a genuine, stated behaviour change (an em-dash in an
  //    SMS built here no longer triggers the brand-voice Chat alert), not a
  //    silent loss -- flagging it here for whoever reviews this rather than
  //    burying it in a commit message.
  function commsSmsNormalisePhoneLocal_(phone) {
    if (!phone) return null;
    var cleaned = String(phone).replace(/[\s\-\(\)\+\.]/g, '');
    if (!cleaned) return null;
    if (/^61[2-578]\d{8}$/.test(cleaned)) return '+' + cleaned;
    if (/^0[2-578]\d{8}$/.test(cleaned)) return '+61' + cleaned.substring(1);
    if (/^4\d{8}$/.test(cleaned)) return '+614' + cleaned.substring(1);
    var original = String(phone).replace(/[\s\-\(\)\.]/g, '');
    if (original.indexOf('+61') === 0 && original.length >= 12) return original;
    return null;
  }

  function commsSmsValidatePhoneLocal_(phone) {
    if (!phone || !String(phone).trim()) {
      return { ok: false, phone: null, error: 'Phone number is required.' };
    }
    var normalised = commsSmsNormalisePhoneLocal_(phone);
    if (!normalised) {
      return { ok: false, phone: null, error: 'Unrecognised phone format: ' + phone + '. Expected Australian mobile (e.g. 0412345678 or +61412345678).' };
    }
    if (normalised.length !== 12) {
      return { ok: false, phone: null, error: 'Phone number has wrong length after normalisation: ' + normalised };
    }
    return { ok: true, phone: normalised, error: null };
  }

  function commsBuildSmsShortcutUrlLocal_(phone, body) {
    var payload = JSON.stringify({ to: phone, body: body || '' });
    return 'shortcuts://run-shortcut?name=CRM%20SMS%20Send&input=text&text=' + encodeURIComponent(payload);
  }

  window.commsOpenInShortcuts = function() {
    var phone = (document.getElementById('comms-sms-to').value || '').trim();
    var body  = (document.getElementById('comms-sms-body').value || '').trim();

    document.getElementById('comms-sms-confirm').classList.remove('show');
    commsHideStatus('comms-sms-status');

    if (!phone || !body) {
      commsShowStatus('comms-sms-status', 'error', 'Phone and message are required.');
      return;
    }

    var validation = commsSmsValidatePhoneLocal_(phone);
    if (!validation.ok) {
      commsShowStatus('comms-sms-status', 'error', validation.error);
      return;
    }

    var url = commsBuildSmsShortcutUrlLocal_(validation.phone, body);

    // Store for confirm step
    commsPendingSmsPhone = validation.phone;
    commsPendingSmsBody  = body;
    // F3b: use location.href inside FluxBuilder WebView so iOS URL scheme triggers
    var inApp = document.documentElement.classList.contains("jv-in-app");
    if (inApp) {
      window.location.href = url;
    } else {
      window.open(url, '_blank');
    }
    document.getElementById('comms-sms-confirm').classList.add('show');
  };

  // Pending SMS state (scoped to module)
  var commsPendingSmsPhone = '';
  var commsPendingSmsBody  = '';

  window.commsConfirmSmsSent = function() {
    document.getElementById('comms-sms-confirm').classList.remove('show');
    commsShowStatus('comms-sms-status', 'info', 'Logging...');

    jvBridge.callAdmin('comms_confirmSmsSent', {
        brideEmail: commsBrideEmail(),
        phone: commsPendingSmsPhone,
        snippet: commsPendingSmsBody.substring(0, 300),
        fullBody: commsPendingSmsBody,
        extra: ''
      })
      .then(function() {
        commsShowStatus('comms-sms-status', 'success', 'SMS logged as sent.');
        document.getElementById('comms-sms-body').value = '';
        commsUpdateSmsCharCount();
        commsPendingSmsPhone = '';
        commsPendingSmsBody  = '';
        commsLoadTimeline();
      })
      .catch(function(err) {
        commsShowStatus('comms-sms-status', 'error', 'Error: ' + (err.message || err));
      });
  };

  window.commsCancelSmsConfirm = function() {
    document.getElementById('comms-sms-confirm').classList.remove('show');
    commsPendingSmsPhone = '';
    commsPendingSmsBody  = '';
  };

  // ── Phase 3: Quick log inbound SMS ─────────────────────────────────────────

  window.commsQuickLogInboundSms = function() {
    var form = document.getElementById('comms-manual-form');
    form.classList.add('open');
    document.getElementById('comms-manual-channel').value   = 'SMS';
    document.getElementById('comms-manual-direction').value = 'INBOUND';
    document.getElementById('comms-manual-body').focus();
    document.getElementById('comms-manual-body').scrollIntoView({ behavior: 'smooth' });
  };

  // ── Phase 4: Template cache ────────────────────────────────────────────────

  var commsTplCache = { EMAIL: [], SMS: [] };

  function commsTplFetchAll(callback) {
    var handle = function(result) {
      var payload = (result && result.data) || result;
      var rows = Array.isArray(payload) ? payload : [];
      commsTplCache.EMAIL = rows.filter(function(r) { return r.channel === 'EMAIL'; });
      commsTplCache.SMS   = rows.filter(function(r) { return r.channel === 'SMS'; });
      commsPopulateTplDropdowns();
      if (callback) callback(rows);
    };

    // CF-first (Comms Slice 3), own flag -- see COMMS_D1_READS_TEMPLATES_ENABLED_'s
    // own header for why this is separate from the umbrella COMMS_D1_READS_ENABLED_.
    // commsD1ProxyCall_ never rejects on a transport failure (it resolves
    // {ok:false,...} instead, same contract every call site in this file
    // already relies on) -- the explicit result.ok check below is what
    // triggers the GAS fallback in that case, not a .catch alone.
    if (COMMS_D1_READS_ENABLED_ || COMMS_D1_READS_TEMPLATES_ENABLED_) {
      commsD1ProxyCall_('templates', {}).then(function(result) {
        if (result && result.ok === false) {
          commsTplFetchAllViaGas_(handle);
          return;
        }
        handle(result);
      }).catch(function() {
        commsTplFetchAllViaGas_(handle);
      });
      return;
    }

    commsTplFetchAllViaGas_(handle);
  }

  // Unused param removed: "handle" closes over the original "callback"
  // from commsTplFetchAll, so this never needs its own copy.
  function commsTplFetchAllViaGas_(handle) {
    // Bridge wraps to { ok, data: [templates] } since the handler returns a flat array.
    // Defensive: accept bridge envelope OR a bare array (legacy/future contract).
    jvBridge.callAdmin('comms_templatesLoadActive', { filter: null })
      .then(handle)
      .catch(function(err) {
        console.error('commsTplFetchAll error: ' + (err.message || err));
      });
  }

  function commsPopulateTplDropdowns() {
    ['EMAIL', 'SMS'].forEach(function(ch) {
      var selectId = ch === 'EMAIL' ? 'comms-email-tpl-select' : 'comms-sms-tpl-select';
      var sel = document.getElementById(selectId);
      if (!sel) return;
      sel.innerHTML = '<option value="">Load Template \u25be</option>';
      commsTplCache[ch].forEach(function(t) {
        var opt = document.createElement('option');
        opt.value = t.template_id;
        opt.textContent = t.name;
        sel.appendChild(opt);
      });
    });
  }

  // ── Phase 4: Apply selected template to compose fields ─────────────────────

  window.commsApplyTemplate = function(channel) {
    var ch = channel.toUpperCase();
    var selectId = ch === 'EMAIL' ? 'comms-email-tpl-select' : 'comms-sms-tpl-select';
    var sel = document.getElementById(selectId);
    if (!sel || !sel.value) return;

    var tplId = sel.value;
    var tpl = commsTplCache[ch].find(function(t) { return t.template_id === tplId; });
    if (!tpl) return;

    // Confirm overwrite before we burn a backend call.
    if (ch === 'EMAIL') {
      var existingSubject = (document.getElementById('comms-compose-subject').value || '').trim();
      var existingBody    = (document.getElementById('comms-compose-body').value || '').trim();
      if ((existingSubject || existingBody) &&
          !confirm('Replace your current draft with this template?')) {
        sel.value = '';
        return;
      }
    } else {
      var existingSmsBody = (document.getElementById('comms-sms-body').value || '').trim();
      if (existingSmsBody && !confirm('Replace your current draft with this template?')) {
        sel.value = '';
        return;
      }
    }

    // Resolve tokens server-side against the current bride's CRM row so
    // {{first_name}} / {{wedding_date}} / {{runsheet_url}} etc. get filled in.
    var brideEmail = commsBrideEmail();
    var statusId = ch === 'EMAIL' ? 'comms-email-status' : 'comms-sms-status';
    commsShowStatus(statusId, 'info', 'Loading template…');

    jvBridge.callAdmin('comms_resolveTemplate', { template_id: tplId, brideEmail: brideEmail })
      .then(function(res) {
        var data = (res && res.data) || res || {};
        if (!data || data.ok === false) {
          throw new Error((data && data.error) || 'Failed to resolve template');
        }
        var subject = data.subject || '';
        var body    = data.body || '';

        if (ch === 'EMAIL') {
          document.getElementById('comms-compose-subject').value = subject;
          document.getElementById('comms-compose-body').value    = body;
          document.getElementById('comms-email-tpl-pill-name').textContent = 'Template: ' + tpl.name;
          document.getElementById('comms-email-tpl-pill').style.display = '';
        } else {
          document.getElementById('comms-sms-body').value = body;
          if (typeof commsUpdateSmsCharCount === 'function') commsUpdateSmsCharCount();
          document.getElementById('comms-sms-tpl-pill-name').textContent = 'Template: ' + tpl.name;
          document.getElementById('comms-sms-tpl-pill').style.display = '';
        }

        if (data.missing && data.missing.length) {
          commsShowStatus(statusId, 'warn',
            'Template loaded. Unresolved tokens: ' + data.missing.map(function(m){return '{{'+m+'}}';}).join(', '));
        } else {
          commsHideStatus(statusId);
        }
      })
      .catch(function(err) {
        // Fall back to raw template text so a backend hiccup doesn't block sending.
        if (ch === 'EMAIL') {
          document.getElementById('comms-compose-subject').value = tpl.subject_template || '';
          document.getElementById('comms-compose-body').value    = tpl.body_template || '';
          document.getElementById('comms-email-tpl-pill-name').textContent = 'Template: ' + tpl.name;
          document.getElementById('comms-email-tpl-pill').style.display = '';
        } else {
          document.getElementById('comms-sms-body').value = tpl.body_template || '';
          if (typeof commsUpdateSmsCharCount === 'function') commsUpdateSmsCharCount();
          document.getElementById('comms-sms-tpl-pill-name').textContent = 'Template: ' + tpl.name;
          document.getElementById('comms-sms-tpl-pill').style.display = '';
        }
        commsShowStatus(statusId, 'error',
          'Tokens not resolved (' + (err.message || err) + '). Raw template loaded; fill placeholders manually.');
      });
  };

  window.commsClearTemplatePill = function(channel) {
    var ch = channel.toUpperCase();
    var selectId = ch === 'EMAIL' ? 'comms-email-tpl-select' : 'comms-sms-tpl-select';
    var pillId   = ch === 'EMAIL' ? 'comms-email-tpl-pill'   : 'comms-sms-tpl-pill';
    document.getElementById(selectId).value = '';
    document.getElementById(pillId).style.display = 'none';
  };

  // ── Phase 4: Templates tab -- load & render ─────────────────────────────────

  window.commsTplLoad = function() {
    var loading = document.getElementById('comms-tpl-loading');
    var list    = document.getElementById('comms-tpl-list');
    if (!loading || !list) return;
    loading.classList.add('visible');
    list.innerHTML = '';

    commsTplFetchAll(function(rows) {
      loading.classList.remove('visible');
      commsRenderTplTable(rows || []);
    });
  };

  function commsRenderTplTable(rows) {
    var list = document.getElementById('comms-tpl-list');
    if (!rows.length) {
      list.innerHTML = '<div class="comms-empty">No templates yet. Click "+ New" to create one.</div>';
      return;
    }

    var html = '<table class="comms-tpl-table">' +
      '<thead><tr>' +
        '<th>Name</th><th>Channel</th><th>Tags</th><th>Status</th><th></th>' +
      '</tr></thead><tbody>';

    rows.forEach(function(t) {
      var tags = (t.tags || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      var tagHtml = tags.map(function(tag) {
        return '<span class="comms-tpl-tag">' + commsEscape(tag) + '</span>';
      }).join('');
      var statusClass = t.active ? 'comms-tpl-status-active' : 'comms-tpl-status-inactive';
      var statusLabel = t.active ? 'Active' : 'Inactive';

      html +=
        '<tr>' +
          '<td>' + commsEscape(t.name || '') + '</td>' +
          '<td>' + commsEscape(t.channel || '') + '</td>' +
          '<td>' + (tagHtml || '\u2014') + '</td>' +
          '<td class="' + statusClass + '">' + statusLabel + '</td>' +
          '<td><div class="comms-tpl-row-actions">' +
            '<button class="comms-tpl-action-btn" onclick="commsTplFormOpen(' + JSON.stringify(t.template_id) + ')">Edit</button>' +
            '<button class="comms-tpl-action-btn" onclick="commsTplToggle(' + JSON.stringify(t.template_id) + ')">Toggle Active</button>' +
          '</div></td>' +
        '</tr>';
    });

    html += '</tbody></table>';
    list.innerHTML = html;
  }

  // ── Phase 4: Template form ─────────────────────────────────────────────────

  window.commsTplFormOpen = function(templateId) {
    var form = document.getElementById('comms-tpl-form');
    document.getElementById('comms-tpl-form-status').className = 'comms-status';
    document.getElementById('comms-tpl-form-status').textContent = '';

    if (templateId) {
      var allTpls = commsTplCache.EMAIL.concat(commsTplCache.SMS);
      var tpl = allTpls.find(function(t) { return t.template_id === templateId; });
      if (!tpl) return;
      document.getElementById('comms-tpl-form-title').textContent = 'Edit Template';
      document.getElementById('comms-tpl-edit-id').value          = tpl.template_id;
      document.getElementById('comms-tpl-name').value             = tpl.name || '';
      document.getElementById('comms-tpl-channel').value          = tpl.channel || 'EMAIL';
      document.getElementById('comms-tpl-subject').value          = tpl.subject_template || '';
      document.getElementById('comms-tpl-body').value             = tpl.body_template || '';
      document.getElementById('comms-tpl-tags').value             = tpl.tags || '';
    } else {
      document.getElementById('comms-tpl-form-title').textContent = 'New Template';
      document.getElementById('comms-tpl-edit-id').value          = '';
      document.getElementById('comms-tpl-name').value             = '';
      document.getElementById('comms-tpl-channel').value          = 'EMAIL';
      document.getElementById('comms-tpl-subject').value          = '';
      document.getElementById('comms-tpl-body').value             = '';
      document.getElementById('comms-tpl-tags').value             = '';
    }

    commsTplChannelChange();
    form.classList.add('open');
    form.scrollIntoView({ behavior: 'smooth' });
  };

  window.commsTplFormClose = function() {
    document.getElementById('comms-tpl-form').classList.remove('open');
  };

  window.commsTplChannelChange = function() {
    var ch = document.getElementById('comms-tpl-channel').value;
    document.getElementById('comms-tpl-subject-row').style.display = ch === 'EMAIL' ? '' : 'none';
  };

  window.commsTplSave = function() {
    var id      = document.getElementById('comms-tpl-edit-id').value.trim();
    var name    = document.getElementById('comms-tpl-name').value.trim();
    var channel = document.getElementById('comms-tpl-channel').value;
    var subject = document.getElementById('comms-tpl-subject').value.trim();
    var body    = document.getElementById('comms-tpl-body').value.trim();
    var tags    = document.getElementById('comms-tpl-tags').value.trim();

    if (!name) { commsShowStatus('comms-tpl-form-status', 'error', 'Name is required.'); return; }
    if (!body) { commsShowStatus('comms-tpl-form-status', 'error', 'Body is required.'); return; }

    commsShowStatus('comms-tpl-form-status', 'info', 'Saving\u2026');

    var payload = { name: name, channel: channel, subject_template: subject,
                    body_template: body, tags: tags, active: true };
    if (id) payload.template_id = id;

    jvBridge.callAdmin('comms_templateSave', { payload: payload })
      .then(function() {
        commsShowStatus('comms-tpl-form-status', 'success', id ? 'Template updated.' : 'Template created.');
        setTimeout(function() { commsTplFormClose(); commsTplLoad(); }, 1000);
      })
      .catch(function(err) {
        commsShowStatus('comms-tpl-form-status', 'error', 'Error: ' + (err.message || err));
      });
  };

  window.commsTplToggle = function(templateId) {
    jvBridge.callAdmin('comms_templateToggle', { templateId: templateId })
      .then(function() { commsTplLoad(); })
      .catch(function(err) {
        alert('Error toggling template: ' + (err.message || err));
      });
  };

  // ── Phase 6: Queue for Cowork Agent ───────────────────────────────────────

  window.commsQueueForCowork = function() {
    var brideEmail = commsBrideEmail();
    var phone = (document.getElementById('comms-sms-to').value || '').trim();
    var body  = (document.getElementById('comms-sms-body').value || '').trim();

    commsHideStatus('comms-cowork-status');

    if (!brideEmail || !phone || !body) {
      commsShowStatus('comms-cowork-status', 'error', 'Phone and message are required.');
      return;
    }

    commsShowStatus('comms-cowork-status', 'info', 'Queuing...');

    jvBridge.callAdmin('comms_queueSmsForCowork', { brideEmail: brideEmail, phone: phone, body: body, extra: '' })
      .then(function(result) {
        if (!result) {
          commsShowStatus('comms-cowork-status', 'error', 'Unexpected error.');
          return;
        }
        // Peel the {ok,data:{...}} bridge envelope before reading handler fields.
        // Without this the parser read status/draft_id off the envelope (always
        // undefined) and fell through to "Unexpected response." even when safe
        // mode correctly blocked the queue (2026-06-06 honest-message fix).
        result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
        if (result && result.ok === false && result.blocked === 'safe_mode') {
          commsShowStatus('comms-cowork-status', 'error', 'Blocked -- safe mode is active. Nothing was sent.');
        } else if (result.status === 'rate_limited') {
          commsShowStatus('comms-cowork-status', 'error', 'Rate limit reached -- try again later.');
        } else if (result.status === 'blocked') {
          commsShowStatus('comms-cowork-status', 'error', 'Blocked -- safe mode is active. Nothing was sent.');
        } else if (result.draft_id) {
          commsShowStatus('comms-cowork-status', 'success', 'Queued for Cowork -- agent will send shortly.');
          document.getElementById('comms-sms-body').value = '';
          commsUpdateSmsCharCount();
          commsRefreshCoworkBadge();
        } else {
          commsShowStatus('comms-cowork-status', 'error', 'Unexpected response.');
        }
      })
      .catch(function(err) {
        commsShowStatus('comms-cowork-status', 'error', 'Error: ' + (err.message || err));
      });
  };

  // ── Phase 6: Pending Cowork badge ─────────────────────────────────────────

  function commsRefreshCoworkBadge() {
    var handle = function(result) {
      result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
      var badge = document.getElementById('comms-cowork-pending-badge');
      if (!badge) return;
      var count = (result && result.count) ? result.count : 0;
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    };

    // CF-first (Comms Slice 4), own flag -- see
    // COMMS_D1_READS_COWORKCOUNT_ENABLED_'s own header. Explicit result.ok
    // check (commsD1ProxyCall_ resolves {ok:false} on transport failure
    // rather than rejecting) falls through to the GAS path, same shape
    // Slice 3 established for templates.
    if (COMMS_D1_READS_ENABLED_ || COMMS_D1_READS_COWORKCOUNT_ENABLED_) {
      commsD1ProxyCall_('drafts', { view: 'cowork_count' }).then(function(result) {
        if (result && result.ok === false) {
          commsRefreshCoworkBadgeViaGas_(handle);
          return;
        }
        handle(result);
      }).catch(function() {
        commsRefreshCoworkBadgeViaGas_(handle);
      });
      return;
    }

    commsRefreshCoworkBadgeViaGas_(handle);
  }

  function commsRefreshCoworkBadgeViaGas_(handle) {
    jvBridge.callAdmin('comms_getPendingCoworkCount', {})
      .then(handle)
      .catch(function() { /* silent -- matches this read's pre-existing posture: a badge count is non-critical, never surface an error banner for it */ });
  }

  // ── Phase 5: Automations tab ───────────────────────────────────────────────

  window.commsAutoLoad = function() {
    var loading = document.getElementById('comms-auto-loading');
    var list    = document.getElementById('comms-auto-list');
    if (!loading || !list) return;
    loading.classList.add('visible');
    list.innerHTML = '';

    var handle = function(rows) {
      loading.classList.remove('visible');
      rows = window.jvUnwrap ? window.jvUnwrap(rows) : ((rows && rows.data) || rows);
      if (rows && !Array.isArray(rows) && Array.isArray(rows.rows)) rows = rows.rows;
      commsRenderAutoTable(Array.isArray(rows) ? rows : []);
    };
    var fail = function(err) {
      loading.classList.remove('visible');
      list.innerHTML = '<div class="comms-auto-empty" style="color:#c0392b;">Error loading automations: ' + commsEscape(err.message || String(err)) + '</div>';
    };

    if (COMMS_D1_READS_ENABLED_) {
      commsD1ProxyCall_('triggers', {}).then(handle).catch(fail);
      return;
    }

    jvBridge.callAdmin('comms_allTriggerRows', {})
      .then(handle)
      .catch(fail);
  };

  function commsRenderAutoTable(rows) {
    var list = document.getElementById('comms-auto-list');
    if (!rows.length) {
      list.innerHTML = '<div class="comms-auto-empty">No trigger rules found. Add rows to the COMMS_TRIGGERS sheet to get started.</div>';
      return;
    }

    var eventLabels = {
      'booking_confirmed':   'Booking Confirmed',
      'trial_date_set':      'Trial Date Set',
      'trial_3_days_out':    'Trial -- 3 Days Out',
      'wedding_4_weeks_out': 'Wedding -- 4 Weeks Out',
      'wedding_1_week_out':  'Wedding -- 1 Week Out'
    };

    var html = '<table class="comms-auto-table">' +
      '<thead><tr>' +
        '<th>Event</th><th>Channel</th><th>Template</th><th>Last Fired</th><th>Active</th>' +
      '</tr></thead><tbody>';

    rows.forEach(function(t) {
      var eventLabel = eventLabels[t.event_name] || commsEscape(t.event_name || '\u2014');
      var channel    = commsEscape(t.channel || '\u2014');
      var tplLabel   = commsEscape(t.template_id || '\u2014');
      var isActive   = t.active === true || String(t.active).toUpperCase() === 'TRUE';

      // Compute "last fired" count from JSON map
      var firedCount = 0;
      try {
        var map = JSON.parse(t.last_fired_bride_key || '{}');
        firedCount = Object.keys(map).length;
      } catch(e) { /* ignore */ }
      var firedLabel = firedCount ? firedCount + ' bride' + (firedCount !== 1 ? 's' : '') : 'Never';

      var toggleId = 'comms-auto-toggle-' + commsEscape(t.trigger_id || '');

      html +=
        '<tr>' +
          '<td>' +
            '<div class="comms-auto-event">' + eventLabel + '</div>' +
            '<div class="comms-auto-meta">' + commsEscape(t.trigger_id || '') + '</div>' +
          '</td>' +
          '<td>' + channel + '</td>' +
          '<td>' + tplLabel + '</td>' +
          '<td class="comms-auto-fired">' + firedLabel + '</td>' +
          '<td>' +
            '<div class="comms-toggle-wrap">' +
              '<input type="checkbox" class="comms-toggle" id="' + toggleId + '"' +
                (isActive ? ' checked' : '') +
                ' data-event-name="' + commsEscape(t.event_name || '') + '"' +
                ' onchange="commsAutoToggle(' + JSON.stringify(t.trigger_id) + ', this)">' +
              '<label class="comms-toggle-label" for="' + toggleId + '">' + (isActive ? 'On' : 'Off') + '</label>' +
            '</div>' +
          '</td>' +
        '</tr>';
    });

    html += '</tbody></table>';
    list.innerHTML = html;
  }

  window.commsAutoToggle = function(triggerId, checkbox) {
    var label = checkbox.parentNode.querySelector('.comms-toggle-label');
    commsHideStatus('comms-auto-status');

    // CF-first (Comms Slice 2, flag default false -- see the flag's own
    // "DO NOT FLIP" checklist above). checkbox.checked is already the NEW
    // desired state at this point (onchange fires after the browser flips
    // it), so this is a plain desired-state write, not a toggle -- matching
    // the outbox write route's own contract (desiredActive, not "flip").
    // On any non-ok response or network failure, falls through to the
    // existing GAS path unchanged -- never double-applies, since a failed/
    // ambiguous CF write never touched server state.
    if (COMMS_D1_WRITE_OUTBOX_ENABLED_) {
      var desiredActive = checkbox.checked;
      checkbox.disabled = true;
      commsD1ProxyCall_('trigger-toggle', {
        triggerId: triggerId,
        eventName: checkbox.getAttribute('data-event-name') || null,
        desiredActive: desiredActive,
        idempotencyKey: commsIdemKey_('trigger-toggle')
      }).then(function(res) {
        if (res && res.ok === true) {
          checkbox.disabled = false;
          if (label) label.textContent = desiredActive ? 'On' : 'Off';
          commsShowStatus('comms-auto-status', 'success', 'Automation ' + (desiredActive ? 'enabled.' : 'disabled.'));
          return;
        }
        commsAutoToggleViaGas_(triggerId, checkbox, label);
      }).catch(function() {
        commsAutoToggleViaGas_(triggerId, checkbox, label);
      });
      return;
    }

    commsAutoToggleViaGas_(triggerId, checkbox, label);
  };

  function commsAutoToggleViaGas_(triggerId, checkbox, label) {
    checkbox.disabled = true;
    jvBridge.callAdmin('comms_triggerToggle', { triggerId: triggerId })
      .then(function(result) {
        result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
        checkbox.disabled = false;
        // Honest feedback on every outcome -- a silent toggle that doesn't persist
        // reads as broken (2026-06-06). Surface success AND failure via the status line.
        if (result && result.status === 'ok') {
          checkbox.checked = result.active;
          if (label) label.textContent = result.active ? 'On' : 'Off';
          commsShowStatus('comms-auto-status', 'success', 'Automation ' + (result.active ? 'enabled.' : 'disabled.'));
        } else if (result && result.ok === false && result.blocked === 'safe_mode') {
          commsShowStatus('comms-auto-status', 'error', 'Blocked -- safe mode is active. Nothing changed.');
          checkbox.checked = !checkbox.checked; // revert
          if (label) label.textContent = checkbox.checked ? 'On' : 'Off';
        } else {
          commsShowStatus('comms-auto-status', 'error', 'Could not toggle automation: ' + (result && result.message ? result.message : 'unexpected response.'));
          checkbox.checked = !checkbox.checked; // revert
          if (label) label.textContent = checkbox.checked ? 'On' : 'Off';
        }
      })
      .catch(function(err) {
        checkbox.disabled = false;
        commsShowStatus('comms-auto-status', 'error', 'Could not toggle automation: ' + (err.message || err));
        checkbox.checked = !checkbox.checked; // revert
        if (label) label.textContent = checkbox.checked ? 'On' : 'Off';
      });
  }

  // ── Task 14: Gmail branch -- triage, drafts, actions ─────────────────────────

  /** Open bride's Gmail threads in a new tab. */
  window.commsOpenInGmail = function() {
    var email = commsBrideEmail();
    if (!email) { alert('No bride email set.'); return; }
    jvBridge.callAdmin('gmail_openInGmail', { email: email })
      .then(function(res) {
        if (res && res.url) window.open(res.url, '_blank');
      })
      .catch(function(err) { alert('Error: ' + (err.message || err)); });
  };

  /** Mark the most recent thread as Follow Up. */
  window.commsMarkFollowUp = function() {
    var email = commsBrideEmail();
    if (!email) { alert('No bride email set.'); return; }
    commsShowStatus('comms-timeline-loading', 'info', 'Marking follow up...');
    jvBridge.callAdmin('gmail_markFollowUp', { email: email, threadId: null, extra: '' })
      .then(function(res) {
        commsHideStatus('comms-timeline-loading');
        if (res && res.ok) {
          commsShowStatus('comms-timeline-loading', 'success', 'Marked as Follow Up');
          setTimeout(function() { commsHideStatus('comms-timeline-loading'); }, 2000);
          commsLoadTriageSummary();
        }
      })
      .catch(function(err) {
        commsHideStatus('comms-timeline-loading');
        alert('Error: ' + (err.message || err));
      });
  };

  /** Create a Gmail draft -- shows inline compose card. */
  window.commsCreateGmailDraft = function() {
    var existing = document.getElementById('comms-gmail-draft-card');
    if (existing) { existing.remove(); return; } // toggle off

    var email = commsBrideEmail();
    if (!email) { alert('No bride email set.'); return; }

    var card = document.createElement('div');
    card.id = 'comms-gmail-draft-card';
    card.className = 'comms-draft-card';
    card.innerHTML =
      '<div class="comms-draft-card-title">Create Gmail Draft</div>' +
      '<div class="comms-field-stack">' +
        '<div class="comms-field"><label>To</label><input type="email" id="comms-gmail-draft-to" value="' + commsEscape(email) + '" readonly></div>' +
        '<div class="comms-field"><label>Subject</label><input type="text" id="comms-gmail-draft-subject" placeholder="Email subject"></div>' +
        '<div class="comms-field"><label>Body</label><textarea id="comms-gmail-draft-body" style="min-height:120px;" placeholder="Draft message..."></textarea></div>' +
      '</div>' +
      '<div id="comms-gmail-draft-status" class="comms-status"></div>' +
      '<div class="comms-form-actions" style="margin-top:12px;">' +
        '<button class="comms-btn comms-btn-primary" onclick="commsSubmitGmailDraft()">Save Draft in Gmail</button>' +
        '<button class="comms-btn comms-btn-ghost" onclick="document.getElementById(\'comms-gmail-draft-card\').remove()">Cancel</button>' +
      '</div>';

    var timeline = document.getElementById('comms-timeline');
    timeline.parentNode.insertBefore(card, timeline);
  };

  /** Submit the Gmail draft form. */
  window.commsSubmitGmailDraft = function() {
    var email   = document.getElementById('comms-gmail-draft-to').value;
    var subject = document.getElementById('comms-gmail-draft-subject').value.trim();
    var body    = document.getElementById('comms-gmail-draft-body').value.trim();

    if (!subject) { commsShowStatus('comms-gmail-draft-status', 'error', 'Subject required.'); return; }
    if (!body)    { commsShowStatus('comms-gmail-draft-status', 'error', 'Body required.'); return; }

    commsShowStatus('comms-gmail-draft-status', 'info', 'Creating Gmail draft...');

    jvBridge.callAdmin('gmail_createDraft', { email: email, subject: subject, body: body, options: {} })
      .then(function(res) {
        if (res && (res.status === 'draft_created' || res.status === 'draft_created_crm_only')) {
          commsShowStatus('comms-gmail-draft-status', 'success', 'Draft created. Open Gmail to review.');
          setTimeout(function() {
            var card = document.getElementById('comms-gmail-draft-card');
            if (card) card.remove();
          }, 2000);
        } else {
          commsShowStatus('comms-gmail-draft-status', 'error', 'Unexpected response.');
        }
      })
      .catch(function(err) {
        commsShowStatus('comms-gmail-draft-status', 'error', 'Error: ' + (err.message || err));
      });
  };

  /** Load triage summary and display badges. */
  window.commsLoadTriageSummary = function() {
    var email = commsBrideEmail();
    if (!email) return;

    jvBridge.callAdmin('gmail_getTriageSummary', { email: email })
      .then(function(summary) {
        var bar = document.getElementById('comms-gmail-triage-bar');
        var badges = document.getElementById('comms-triage-badges');
        if (!summary || !summary.total_threads) {
          bar.style.display = 'none';
          return;
        }

        bar.style.display = '';
        var html = '';
        if (summary.urgent > 0) {
          html += '<span class="comms-triage-pill urgent"><span class="comms-triage-count">' + summary.urgent + '</span> Urgent</span>';
        }
        if (summary.needs_reply > 0) {
          html += '<span class="comms-triage-pill needs-reply"><span class="comms-triage-count">' + summary.needs_reply + '</span> Needs Reply</span>';
        }
        if (summary.follow_up > 0) {
          html += '<span class="comms-triage-pill follow-up"><span class="comms-triage-count">' + summary.follow_up + '</span> Follow Up</span>';
        }
        if (summary.waiting > 0) {
          html += '<span class="comms-triage-pill waiting"><span class="comms-triage-count">' + summary.waiting + '</span> Waiting</span>';
        }
        if (!html) {
          html = '<span class="comms-triage-pill">' + summary.total_threads + ' threads -- no triage labels</span>';
        }
        badges.innerHTML = html;
      })
      .catch(function() {
        // Silently fail -- triage is optional
        document.getElementById('comms-gmail-triage-bar').style.display = 'none';
      });
  };

  /** Set triage status on a specific thread from timeline row. */
  window.commsSetTriageFromRow = function(threadId, selectEl) {
    var status = selectEl.value;
    if (!status) return;

    var email = commsBrideEmail();
    selectEl.disabled = true;

    jvBridge.callAdmin('gmail_setTriageStatus', { email: email, threadId: threadId, status: status, extra: '' })
      .then(function() {
        selectEl.disabled = false;
        commsLoadTriageSummary();
      })
      .catch(function(err) {
        selectEl.disabled = false;
        alert('Error: ' + (err.message || err));
      });
  };

  /** Open a specific Gmail thread in a new tab. */
  window.commsOpenThread = function(threadId) {
    jvBridge.callAdmin('gmail_getThreadUrl', { threadId: threadId })
      .then(function(res) {
        res = window.jvUnwrap ? window.jvUnwrap(res) : ((res && res.data) || res);
        if (res && res.url) window.open(res.url, '_blank');
      })
      .catch(function(err) { console.error('gmail_getThreadUrl failed:', err && err.message || err); });
  };

  /** Sync a single thread.
   * (2026-07-19, WS-3 perf fix) Refreshes via commsRefreshTimelineQuiet_
   * instead of the full commsLoadTimeline(), so the already-rendered timeline
   * stays on screen during the refresh instead of dropping to a blank
   * "Loading communications..." state for one thread's sync. */
  window.commsSyncThread = function(threadId) {
    var email = commsBrideEmail();
    jvBridge.callAdmin('gmail_syncSingleThread', { threadId: threadId, email: email })
      .then(function() { commsRefreshTimelineQuiet_(email); })
      .catch(function(err) { alert('Sync error: ' + (err.message || err)); });
  };

  // ── Phase 7: AI Assist tab ─────────────────────────────────────────────────

  var _commsAiCurrentDraftId = null;

  function commsAiSetStageLabel(stage) {
    var el = document.getElementById('comms-ai-stage-label');
    if (!el) return;
    var labels = { 'PENDING_AI_DRAFT': 'Pending Draft', 'DRAFT_READY': 'Draft Ready', 'PENDING_REVIEW': 'Pending Review', 'APPROVED_TO_SEND': 'Approved', 'REJECTED': 'Rejected', 'SENT': 'Sent', 'FAILED': 'Failed' };
    el.textContent = labels[stage] || stage || 'No active draft';
    el.setAttribute('data-stage', stage || '');
  }

  // commsAiShowStakesUnknown_(): renders the "could not verify" state, using the
  // same visual slot as a genuine high-stakes hit (visible banner + badge),
  // never the same as "confirmed safe" (hidden). A caller who cannot tell
  // whether this draft is high-stakes must not present that as equivalent to
  // having checked and found nothing. See comms_checkHighStakes_'s header
  // comment (CommsAIDraft.gs) for the server-side half of this fix, 2026-09-23.
  function commsAiShowStakesUnknown_(reason) {
    var banner = document.getElementById('comms-ai-stakes-banner');
    var badge  = document.getElementById('comms-ai-stakes-badge');
    if (banner) {
      banner.style.display = '';
      var flagsEl = document.getElementById('comms-ai-stakes-flags');
      if (flagsEl) flagsEl.innerHTML = '<div style="font-size:12px;margin:1px 0">Could not verify high-stakes status (' + commsEscape(reason) + '). Review before sending.</div>';
    }
    if (badge) { badge.textContent = '?'; badge.style.display = ''; badge.style.background = '#e8a030'; }
  }

  window.commsAiCheckStakes = function() {
    var email = commsBrideEmail();
    if (!email) return;
    jvBridge.callAdmin('comms_checkHighStakes', { email: email, extra: '' })
      .then(function(result) {
        result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
        var banner = document.getElementById('comms-ai-stakes-banner');
        var badge  = document.getElementById('comms-ai-stakes-badge');
        if (!result) {
          // Request-level failure (unwrap gave nothing back). Fail closed,
          // never silently identical to "confirmed safe".
          commsAiShowStakesUnknown_('request failed');
          return;
        }
        if (result.confidenceUnknown) {
          // Server-side lookup failure (see reviewRequired/confidenceUnknown
          // in CommsAIDraft.gs). Same fail-closed treatment as a request
          // failure, plus still surfaces any keyword flags that DID match.
          commsAiShowStakesUnknown_((result.sourcesUnavailable || []).join(', ') || 'unknown');
          return;
        }
        if (!result.isHighStakes) {
          if (banner) banner.style.display = 'none';
          if (badge) badge.style.display = 'none';
          return;
        }
        if (banner) {
          banner.style.display = '';
          var flagsEl = document.getElementById('comms-ai-stakes-flags');
          if (flagsEl) flagsEl.innerHTML = result.flags.map(function(f) { return '<div style="font-size:12px;margin:1px 0">' + commsEscape(f.label) + '</div>'; }).join('');
        }
        if (badge) { badge.textContent = '!'; badge.style.display = ''; badge.style.background = '#e8a030'; }
      })
      .catch(function() {
        // Transport-level failure. Same fail-closed treatment, not a silent no-op.
        commsAiShowStakesUnknown_('network error');
      });
  };

  window.commsAiDraftChatGPT = function() {
    var email = commsBrideEmail();
    if (!email) { commsShowStatus('comms-ai-draft-status', 'error', 'No bride selected -- open a CRM record first.'); return; }
    var channel = document.getElementById('comms-ai-channel').value;
    var instructions = document.getElementById('comms-ai-instructions').value;
    commsShowStatus('comms-ai-draft-status', 'info', 'Generating ChatGPT brief...');
    jvBridge.callAdmin('comms_buildChatGPTPrompt', { email: email, channel: channel, instructions: instructions })
      .then(function(result) {
        result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
        if (!result || !result.prompt) { commsShowStatus('comms-ai-draft-status', 'error', 'Failed to generate prompt.'); return; }
        _commsAiCurrentDraftId = result.draftId || null;
        commsAiSetStageLabel('PENDING_AI_DRAFT');
        var card = document.getElementById('comms-ai-draft-card');
        if (card) card.style.display = '';
        var idEl = document.getElementById('comms-ai-draft-id');
        if (idEl) idEl.textContent = _commsAiCurrentDraftId || '';
        commsAiCopyToClipboard(result.prompt, 'comms-ai-draft-status', 'ChatGPT brief copied to clipboard.');
        if (result.highStakes && result.highStakes.isHighStakes) {
          var banner = document.getElementById('comms-ai-stakes-banner');
          if (banner) {
            banner.style.display = '';
            var flagsEl = document.getElementById('comms-ai-stakes-flags');
            if (flagsEl) flagsEl.innerHTML = result.highStakes.flags.map(function(f) { return '<div style="font-size:12px;margin:1px 0">' + commsEscape(f.label) + '</div>'; }).join('');
          }
        }
      })
      .catch(function(err) { commsShowStatus('comms-ai-draft-status', 'error', 'Error: ' + (err.message || err)); });
  };

  window.commsAiCopyChatGPT = function() {
    var email = commsBrideEmail();
    if (!email) { commsShowStatus('comms-ai-draft-status', 'error', 'No bride selected.'); return; }
    var channel = document.getElementById('comms-ai-channel').value;
    var instructions = document.getElementById('comms-ai-instructions').value;
    commsShowStatus('comms-ai-draft-status', 'info', 'Generating brief...');
    jvBridge.callAdmin('comms_buildChatGPTPrompt', { email: email, channel: channel, instructions: instructions })
      .then(function(result) {
        result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
        if (!result || !result.prompt) { commsShowStatus('comms-ai-draft-status', 'error', 'Failed to generate prompt.'); return; }
        commsAiCopyToClipboard(result.prompt, 'comms-ai-draft-status', 'ChatGPT brief copied to clipboard.');
      })
      .catch(function(err) { commsShowStatus('comms-ai-draft-status', 'error', 'Error: ' + (err.message || err)); });
  };

  window.commsAiSaveDraft = function() {
    var email = commsBrideEmail();
    var channel = document.getElementById('comms-ai-channel').value;
    var body = (document.getElementById('comms-ai-draft-body') || {}).value || '';
    if (!body.trim()) { commsShowStatus('comms-ai-draft-status', 'error', 'Paste the ChatGPT draft first.'); return; }
    var subject = '';
    if (channel === 'EMAIL' && body.indexOf('Subject:') === 0) {
      var lines = body.split('\n');
      subject = lines[0].replace(/^Subject:\s*/i, '').trim();
      body = lines.slice(1).join('\n').trim();
    }
    commsShowStatus('comms-ai-draft-status', 'info', 'Saving draft...');
    jvBridge.callAdmin('comms_saveDraftFromAI', { email: email, channel: channel, body: body, subject: subject, draftId: _commsAiCurrentDraftId, source: 'chatgpt' })
      .then(function(result) {
        if (result && result.draft_id) {
          _commsAiCurrentDraftId = result.draft_id;
          commsAiSetStageLabel(result.ai_stage || 'DRAFT_READY');
          commsShowStatus('comms-ai-draft-status', 'success', 'Draft saved. Ready for review.');
          var idEl = document.getElementById('comms-ai-draft-id');
          if (idEl) idEl.textContent = result.draft_id;
        } else { commsShowStatus('comms-ai-draft-status', 'error', 'Save failed.'); }
      })
      .catch(function(err) { commsShowStatus('comms-ai-draft-status', 'error', 'Error: ' + (err.message || err)); });
  };

  window.commsAiReviewClaude = function() {
    var email = commsBrideEmail();
    var draftBody = (document.getElementById('comms-ai-draft-body') || {}).value || '';
    if (!draftBody.trim()) { commsShowStatus('comms-ai-review-status', 'error', 'No draft to review -- paste or generate a draft first.'); return; }
    var channel = document.getElementById('comms-ai-channel').value;
    commsShowStatus('comms-ai-review-status', 'info', 'Generating Claude review brief...');
    jvBridge.callAdmin('comms_buildClaudeReviewPrompt', { email: email, draftBody: draftBody, channel: channel, draftId: _commsAiCurrentDraftId })
      .then(function(result) {
        result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
        if (!result || !result.prompt) { commsShowStatus('comms-ai-review-status', 'error', 'Failed to generate review prompt.'); return; }
        commsAiSetStageLabel('PENDING_REVIEW');
        commsAiCopyToClipboard(result.prompt, 'comms-ai-review-status', 'Claude review brief copied to clipboard.');
        var card = document.getElementById('comms-ai-review-card');
        if (card) card.style.display = '';
      })
      .catch(function(err) { commsShowStatus('comms-ai-review-status', 'error', 'Error: ' + (err.message || err)); });
  };

  window.commsAiCopyClaudeReview = function() {
    var email = commsBrideEmail();
    var draftBody = (document.getElementById('comms-ai-draft-body') || {}).value || '';
    if (!draftBody.trim()) { commsShowStatus('comms-ai-review-status', 'error', 'No draft to review.'); return; }
    var channel = document.getElementById('comms-ai-channel').value;
    commsShowStatus('comms-ai-review-status', 'info', 'Generating brief...');
    jvBridge.callAdmin('comms_buildClaudeReviewPrompt', { email: email, draftBody: draftBody, channel: channel, draftId: null })
      .then(function(result) {
        result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
        if (!result || !result.prompt) { commsShowStatus('comms-ai-review-status', 'error', 'Failed.'); return; }
        commsAiCopyToClipboard(result.prompt, 'comms-ai-review-status', 'Claude review brief copied to clipboard.');
      })
      .catch(function(err) { commsShowStatus('comms-ai-review-status', 'error', 'Error: ' + (err.message || err)); });
  };

  window.commsAiApprove = function() {
    if (!_commsAiCurrentDraftId) { commsShowStatus('comms-ai-review-status', 'error', 'No active draft to approve.'); return; }
    var notes = (document.getElementById('comms-ai-review-notes') || {}).value || '';
    commsShowStatus('comms-ai-review-status', 'info', 'Approving...');

    // CF-first (Comms Slice 2, flag default false). On non-ok/network
    // failure, falls through to the unchanged GAS path -- never double-
    // applies, since a failed/ambiguous outbox write never reached GAS.
    if (COMMS_D1_WRITE_OUTBOX_ENABLED_) {
      commsD1ProxyCall_('draft-stage', {
        draftId: _commsAiCurrentDraftId,
        brideEmail: commsBrideEmail() || null,
        newStage: 'APPROVED_TO_SEND',
        reviewNotes: notes || 'Approved',
        idempotencyKey: commsIdemKey_('draft-approve')
      }).then(function(res) {
        if (res && res.ok === true) {
          commsAiSetStageLabel('APPROVED_TO_SEND');
          commsShowStatus('comms-ai-review-status', 'success', 'Draft approved -- will send once the next sync drains it.');
          return;
        }
        commsAiApproveViaGas_(notes);
      }).catch(function() { commsAiApproveViaGas_(notes); });
      return;
    }

    commsAiApproveViaGas_(notes);
  };

  function commsAiApproveViaGas_(notes) {
    jvBridge.callAdmin('comms_approveDraft', { draftId: _commsAiCurrentDraftId, notes: notes || 'Approved' })
      .then(function(result) {
        // Fixed 2026-08-29 (COMMS-approved-drafts-stale-check-and-ux-mismatch):
        // this previously said "ready to send via Compose tab", implying a
        // manual next step. In reality comms_processPendingApprovedDrafts_
        // (CommsApprovedDraftWorker_2026_05_26.gs) auto-sends this draft on
        // the next hourly task-engine tick with no further admin action.
        if (result && result.ok) { commsAiSetStageLabel('APPROVED_TO_SEND'); commsShowStatus('comms-ai-review-status', 'success', 'Draft approved -- will send automatically within the hour.'); }
        else { commsShowStatus('comms-ai-review-status', 'error', (result && (result.message || result.error)) || 'Approval failed.'); } // P0.8: surface review_required
      })
      .catch(function(err) { commsShowStatus('comms-ai-review-status', 'error', 'Error: ' + (err.message || err)); });
  }

  window.commsAiReject = function() {
    if (!_commsAiCurrentDraftId) { commsShowStatus('comms-ai-review-status', 'error', 'No active draft to reject.'); return; }
    var notes = (document.getElementById('comms-ai-review-notes') || {}).value || '';
    if (!notes.trim()) { commsShowStatus('comms-ai-review-status', 'error', 'Add review notes before rejecting.'); return; }
    commsShowStatus('comms-ai-review-status', 'info', 'Rejecting...');

    if (COMMS_D1_WRITE_OUTBOX_ENABLED_) {
      var rejectDraftId = _commsAiCurrentDraftId;
      commsD1ProxyCall_('draft-stage', {
        draftId: rejectDraftId,
        brideEmail: commsBrideEmail() || null,
        newStage: 'REJECTED',
        reviewNotes: notes,
        idempotencyKey: commsIdemKey_('draft-reject')
      }).then(function(res) {
        if (res && res.ok === true) {
          commsAiSetStageLabel('REJECTED');
          commsShowStatus('comms-ai-review-status', 'info', 'Draft rejected.');
          _commsAiCurrentDraftId = null;
          return;
        }
        commsAiRejectViaGas_(notes);
      }).catch(function() { commsAiRejectViaGas_(notes); });
      return;
    }

    commsAiRejectViaGas_(notes);
  };

  function commsAiRejectViaGas_(notes) {
    jvBridge.callAdmin('comms_rejectDraft', { draftId: _commsAiCurrentDraftId, notes: notes })
      .then(function(result) {
        if (result && result.ok) { commsAiSetStageLabel('REJECTED'); commsShowStatus('comms-ai-review-status', 'info', 'Draft rejected.'); _commsAiCurrentDraftId = null; }
        else { commsShowStatus('comms-ai-review-status', 'error', 'Rejection failed.'); }
      })
      .catch(function(err) { commsShowStatus('comms-ai-review-status', 'error', 'Error: ' + (err.message || err)); });
  }

  window.commsAiLoadQueue = function() {
    var loading = document.getElementById('comms-ai-queue-loading');
    var list = document.getElementById('comms-ai-queue-list');
    if (!loading || !list) return;
    loading.classList.add('visible');
    list.innerHTML = '';

    var handle = function(rows) {
      loading.classList.remove('visible');
      rows = window.jvUnwrap ? window.jvUnwrap(rows) : ((rows && rows.data) || rows);
      if (rows && !Array.isArray(rows) && Array.isArray(rows.drafts)) rows = rows.drafts;
      commsAiRenderQueue(Array.isArray(rows) ? rows : []);
    };
    var fail = function(err) {
      loading.classList.remove('visible');
      list.innerHTML = '<div class="comms-empty" style="color:#c0392b">Error: ' + commsEscape(err.message || String(err)) + '</div>';
    };

    // CF-first (Comms Slice 6), own flag -- see
    // COMMS_D1_READS_AIQUEUE_ENABLED_'s own header. Explicit result.ok
    // check (commsD1ProxyCall_ resolves {ok:false} on transport failure
    // rather than rejecting) falls through to the GAS path, same shape
    // Slices 3/4/5 established -- the pre-existing branch here already had
    // a real .catch(fail), but no result.ok check, so a {ok:false} response
    // would have been handed to handle() as if it were real queue data.
    if (COMMS_D1_READS_ENABLED_ || COMMS_D1_READS_AIQUEUE_ENABLED_) {
      commsD1ProxyCall_('drafts', { view: 'ai_queue' }).then(function(result) {
        if (result && result.ok === false) {
          commsAiLoadQueueViaGas_(handle, fail);
          return;
        }
        handle(result);
      }).catch(function() {
        commsAiLoadQueueViaGas_(handle, fail);
      });
      return;
    }

    commsAiLoadQueueViaGas_(handle, fail);
  };

  function commsAiLoadQueueViaGas_(handle, fail) {
    jvBridge.callAdmin('comms_getAIDraftQueue', { filter: null })
      .then(handle)
      .catch(fail);
  }

  function commsAiRenderQueue(rows) {
    var list = document.getElementById('comms-ai-queue-list');
    if (!rows.length) { list.innerHTML = '<div class="comms-empty">No active AI drafts in queue.</div>'; return; }
    var stageColors = { 'PENDING_AI_DRAFT': '#e8f0fe', 'DRAFT_READY': '#e6f4ea', 'PENDING_REVIEW': '#fef3cd', 'APPROVED_TO_SEND': '#d4edda' };
    var stageLabels = { 'PENDING_AI_DRAFT': 'Pending', 'DRAFT_READY': 'Ready', 'PENDING_REVIEW': 'Review', 'APPROVED_TO_SEND': 'Approved' };
    var html = '';
    rows.forEach(function(r) {
      var stage = r.ai_stage || '', bg = stageColors[stage] || '#f0ebe8', label = stageLabels[stage] || stage;
      html += '<div class="comms-ai-queue-row" onclick="commsAiLoadDraft(\'' + commsEscape(r.draft_id || '') + '\')">' +
        '<div class="comms-ai-queue-bride">' + commsEscape(r.bride_email || '') + '</div>' +
        '<div class="comms-ai-queue-channel comms-badge-' + commsEscape(r.channel || '') + '">' + commsEscape(r.channel || '') + '</div>' +
        '<div class="comms-ai-queue-stage" style="background:' + bg + '">' + label + '</div>' +
        '<div style="font-size:11px;color:var(--text-light)">' + (r.created_at ? commsFormatDate(r.created_at) : '') + '</div>' +
      '</div>';
    });
    list.innerHTML = html;
  }

  // Fixed 2026-08-29 (COMMS-ai-draft-queue-empty-shell): this previously only
  // stored the draft id and revealed an empty card shell, it never fetched
  // the draft's actual body/subject/review data, so clicking a queue row (or
  // the equivalent Approval Queue card) looked like it did something but
  // showed nothing real. Now fetches the full record via the new
  // comms_getDraftById route and populates every field the card is
  // structured to show.
  window.commsAiLoadDraft = function(draftId) {
    _commsAiCurrentDraftId = draftId;
    var idEl = document.getElementById('comms-ai-draft-id');
    if (idEl) idEl.textContent = draftId;
    var card = document.getElementById('comms-ai-draft-card');
    if (card) card.style.display = '';
    commsShowStatus('comms-ai-draft-status', 'info', 'Loading draft ' + draftId + '...');

    jvBridge.callAdmin('comms_getDraftById', { draftId: draftId })
      .then(function(result) {
        result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
        if (!result) {
          commsShowStatus('comms-ai-draft-status', 'error', 'Draft ' + draftId + ' not found.');
          return;
        }

        // Fixed 2026-09-02 (checklist item 9): previously only set the dropdown
        // when result.channel was truthy, so a row with a genuinely blank
        // channel cell (confirmed via JV_comms_diagnoseDraftChannelMismatch:
        // no duplicate draft_id rows, ruling out the original hypothesis)
        // silently left whichever channel the PREVIOUS draft had loaded still
        // showing, mislabeled as belonging to this draft. Always set it now,
        // explicitly falling back to a blank value so a blank cell can never
        // inherit stale state from an earlier load.
        var channelEl = document.getElementById('comms-ai-channel');
        if (channelEl) channelEl.value = result.channel || '';

        var subjectEl = document.getElementById('comms-ai-draft-subject');
        if (subjectEl) {
          if (result.subject) { subjectEl.textContent = result.subject; subjectEl.style.display = ''; }
          else { subjectEl.textContent = ''; subjectEl.style.display = 'none'; }
        }

        var bodyEl = document.getElementById('comms-ai-draft-body');
        if (bodyEl) bodyEl.value = result.body || '';

        var reviewNotesEl = document.getElementById('comms-ai-review-notes');
        var reviewCard = document.getElementById('comms-ai-review-card');
        if (reviewNotesEl) reviewNotesEl.value = result.review_notes || '';
        if (reviewCard) reviewCard.style.display = result.review_notes ? '' : 'none';

        if (result.ai_stage) commsAiSetStageLabel(result.ai_stage);

        commsShowStatus('comms-ai-draft-status', 'success', 'Draft ' + draftId + ' loaded.');
      })
      .catch(function(err) {
        commsShowStatus('comms-ai-draft-status', 'error', 'Error loading draft: ' + (err.message || err));
      });
  };

  function commsAiCopyToClipboard(text, statusElId, successMsg) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() { commsShowStatus(statusElId, 'success', successMsg); })
        .catch(function() { commsAiFallbackCopy(text, statusElId, successMsg); });
    } else { commsAiFallbackCopy(text, statusElId, successMsg); }
  }

  function commsAiFallbackCopy(text, statusElId, successMsg) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.left = '-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); commsShowStatus(statusElId, 'success', successMsg); }
    catch (e) { commsShowStatus(statusElId, 'info', 'Could not auto-copy -- select and copy manually.'); }
    document.body.removeChild(ta);
  }

  // ── Task 18: Timeline filter ───────────────────────────────────────────────

  var _commsTimelineRows = []; // cached rows for client-side filtering

  window.commsApplyFilters = function() {
    var chFilter  = document.getElementById('comms-filter-channel').value;
    var dirFilter = document.getElementById('comms-filter-direction').value;
    var stFilter  = document.getElementById('comms-filter-status').value;

    var filtered = _commsTimelineRows.filter(function(row) {
      if (chFilter && (row.channel || '').toUpperCase() !== chFilter) return false;
      if (dirFilter && (row.direction || '').toUpperCase() !== dirFilter) return false;
      if (stFilter && (row.status || '').toUpperCase() !== stFilter) return false;
      return true;
    });

    commsRenderTimeline(filtered, true);
  };

  window.commsResetFilters = function() {
    document.getElementById('comms-filter-channel').value = '';
    document.getElementById('comms-filter-direction').value = '';
    document.getElementById('comms-filter-status').value = '';
    commsRenderTimeline(_commsTimelineRows, true);
  };

  // ── Task 18: Meta DM compose ──────────────────────────────────────────────

  function commsLoadMetaRecipient(ch) {
    var email = commsBrideEmail();
    if (!email) return;

    jvBridge.callAdmin('meta_getSocialLinksForBride', { email: email })
      .then(function(links) {
        if (!links || !links.length) return;
        var platform = ch === 'ig_dm' ? 'instagram' : 'facebook';
        var match = links.find(function(l) { return (l.platform || '').toLowerCase() === platform; });
        if (match) {
          var fieldId = ch === 'ig_dm' ? 'comms-ig-recipient' : 'comms-fb-recipient';
          document.getElementById(fieldId).value = match.social_user_id || '';
        }
      })
      .catch(function() { /* silent */ });
  }

  window.commsSendMetaDm = function(channel) {
    var email = commsBrideEmail();
    if (!email) { commsShowMetaDmStatus(channel, 'error', 'No bride selected.'); return; }

    var isIg = channel === 'INSTAGRAM_DM';
    var recipientId = document.getElementById(isIg ? 'comms-ig-recipient' : 'comms-fb-recipient').value.trim();
    var body = document.getElementById(isIg ? 'comms-ig-body' : 'comms-fb-body').value.trim();

    if (!recipientId) { commsShowMetaDmStatus(channel, 'error', 'No recipient linked. Link via Social Links first.'); return; }
    if (!body) { commsShowMetaDmStatus(channel, 'error', 'Message is required.'); return; }

    commsShowMetaDmStatus(channel, 'info', 'Sending...');

    var sendFn = isIg ? 'meta_sendInstagramDm_' : 'meta_sendFacebookDm_';
    jvBridge.callAdmin(sendFn, { recipientId: recipientId, body: body, email: email })
      .then(function(result) {
        if (result && result.status === 'sent') {
          commsShowMetaDmStatus(channel, 'success', 'Message sent.');
          document.getElementById(isIg ? 'comms-ig-body' : 'comms-fb-body').value = '';
        } else if (result && result.status === 'blocked') {
          commsShowMetaDmStatus(channel, 'error', 'Blocked -- safe mode active.');
        } else if (result && result.status === 'window_closed') {
          commsShowMetaDmStatus(channel, 'error', '24-hour messaging window closed. Bride must message first.');
        } else {
          commsShowMetaDmStatus(channel, 'error', (result && result.message) || 'Send failed.');
        }
      })
      .catch(function(err) {
        commsShowMetaDmStatus(channel, 'error', 'Error: ' + (err.message || err));
      });
  };

  window.commsCheckMetaWindow = function(channel) {
    var email = commsBrideEmail();
    if (!email) return;
    var isIg = channel === 'INSTAGRAM_DM';
    var recipientId = document.getElementById(isIg ? 'comms-ig-recipient' : 'comms-fb-recipient').value.trim();
    if (!recipientId) {
      commsShowMetaDmStatus(channel, 'error', 'No recipient linked.');
      return;
    }

    jvBridge.callAdmin('meta_checkMessagingWindow', { recipientId: recipientId, channel: channel })
      .then(function(result) {
        var badgeId = isIg ? 'comms-ig-window-badge' : 'comms-fb-window-badge';
        var badge = document.getElementById(badgeId);
        if (!result) { badge.style.display = 'none'; return; }
        badge.style.display = '';
        if (result.within_window) {
          badge.className = 'comms-meta-window-badge open';
          badge.textContent = 'Window open -- expires ' + commsFormatDate(result.window_expires);
        } else {
          badge.className = 'comms-meta-window-badge closed';
          badge.textContent = 'Window closed -- bride must message first';
        }
      })
      .catch(function() { /* silent */ });
  };

  function commsShowMetaDmStatus(channel, type, msg) {
    var statusId = channel === 'INSTAGRAM_DM' ? 'comms-ig-status' : 'comms-fb-status';
    commsShowStatus(statusId, type, msg);
  }

  // ── Task 18: Approval Queue ───────────────────────────────────────────────

  window.commsQueueLoad = function() {
    var loading = document.getElementById('comms-queue-loading');
    if (loading) loading.classList.add('visible');

    var handle = function(result) {
      if (loading) loading.classList.remove('visible');
      result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
      commsRenderQueue(result || { drafts: [], needs_draft: 0, needs_review: 0, approved: 0, sent: 0 });
    };
    var fail = function(err) {
      if (loading) loading.classList.remove('visible');
      var list = document.getElementById('comms-queue-needs-draft');
      if (list) list.innerHTML = '<div class="comms-empty" style="color:#c0392b">Error: ' + commsEscape(err.message || String(err)) + '</div>';
    };

    // CF-first (Comms Slice 5), own flag -- see
    // COMMS_D1_READS_APPROVALQUEUE_ENABLED_'s own header. Explicit
    // result.ok check (commsD1ProxyCall_ resolves {ok:false} on transport
    // failure rather than rejecting) falls through to the GAS path, same
    // shape Slices 3/4 established.
    if (COMMS_D1_READS_ENABLED_ || COMMS_D1_READS_APPROVALQUEUE_ENABLED_) {
      commsD1ProxyCall_('drafts', { view: 'approval_queue' }).then(function(result) {
        if (result && result.ok === false) {
          commsQueueLoadViaGas_(handle, fail);
          return;
        }
        handle(result);
      }).catch(function() {
        commsQueueLoadViaGas_(handle, fail);
      });
      return;
    }

    commsQueueLoadViaGas_(handle, fail);
  };

  function commsQueueLoadViaGas_(handle, fail) {
    jvBridge.callAdmin('comms_getApprovalQueue', {})
      .then(handle)
      .catch(fail);
  }

  function commsRenderQueue(data) {
    var drafts = data.drafts || [];

    // Summary counts
    var countsEl = document.getElementById('comms-queue-counts');
    if (countsEl) {
      countsEl.innerHTML =
        '<div class="comms-queue-count-pill"><span class="count">' + (data.needs_draft || 0) + '</span> Needs Draft</div>' +
        '<div class="comms-queue-count-pill"><span class="count">' + (data.needs_review || 0) + '</span> Needs Review</div>' +
        '<div class="comms-queue-count-pill"><span class="count">' + (data.approved || 0) + '</span> Approved</div>' +
        '<div class="comms-queue-count-pill"><span class="count">' + (data.sent || 0) + '</span> Sent</div>';
    }

    // Update queue tab badge
    var totalPending = (data.needs_draft || 0) + (data.needs_review || 0) + (data.approved || 0);
    var badge = document.getElementById('comms-queue-badge');
    if (badge) {
      if (totalPending > 0) { badge.textContent = totalPending; badge.style.display = ''; }
      else { badge.style.display = 'none'; }
    }

    // Categorise drafts
    var buckets = { needs_draft: [], needs_review: [], approved: [], sent: [] };
    drafts.forEach(function(d) {
      var stage = (d.ai_stage || d.status || '').toUpperCase();
      if (stage === 'PENDING_AI_DRAFT' || stage === 'REPLY_NEEDED') {
        buckets.needs_draft.push(d);
      } else if (stage === 'DRAFT_READY' || stage === 'PENDING_REVIEW') {
        buckets.needs_review.push(d);
      } else if (stage === 'APPROVED_TO_SEND') {
        buckets.approved.push(d);
      } else if (stage === 'SENT') {
        buckets.sent.push(d);
      } else {
        buckets.needs_draft.push(d); // default
      }
    });

    var stageClassMap = {
      'needs_draft': 'needs-draft',
      'needs_review': 'needs-review',
      'approved': 'approved',
      'sent': 'sent'
    };

    Object.keys(buckets).forEach(function(key) {
      var el = document.getElementById('comms-queue-' + key.replace(/_/g, '-'));
      if (!el) return;
      var items = buckets[key];
      if (!items.length) {
        el.innerHTML = '<div class="comms-empty" style="padding:10px">None</div>';
        return;
      }
      el.innerHTML = items.map(function(d) {
        var channelBadge = 'comms-badge-' + (d.channel || 'SYSTEM');
        var stageBadgeClass = stageClassMap[key] || 'needs-draft';
        var stageLabel = (d.ai_stage || d.status || '').replace(/_/g, ' ');
        return '<div class="comms-queue-card" onclick="commsQueueOpenDraft(\'' + commsEscape(d.draft_id || '') + '\')">' +
          '<div class="comms-queue-bride">' + commsEscape(d.bride_email || '') + '</div>' +
          '<div class="comms-queue-channel comms-badge ' + channelBadge + '">' + commsEscape(d.channel || '') + '</div>' +
          '<div class="comms-queue-stage-badge ' + stageBadgeClass + '">' + commsEscape(stageLabel) + '</div>' +
          '<div class="comms-queue-date">' + commsFormatDate(d.created_at) + '</div>' +
        '</div>';
      }).join('');
    });
  }

  window.commsQueueOpenDraft = function(draftId) {
    // Switch to AI Assist tab and load this draft
    commsShowTab('ai');
    commsAiLoadDraft(draftId);
  };

  // ── Recipient picker ───────────────────────────────────────────────────────

  var commsSearchDebounce = null;
  var commsSearchAbortSeq = 0;
  // Request-storm fix (2026-09-23, Cowork audit finding: "30+ retries and
  // several 504s before resolving" on bridge_admin_searchBrides). The
  // existing seq guard only suppressed RENDERING a stale response -- it
  // never stopped the underlying fetch from firing. Typing a real name at
  // normal speed fires one debounced call per pause-in-typing, and since
  // jvBridge's shared transport has no caller-supplied abort signal (adding
  // one there is bigger, riskier surgery on a file every admin/team page
  // depends on), a slow GAS instance meant several of those calls were
  // genuinely concurrent in-flight requests, each independently eligible
  // for jvBridge's own 1-retry-on-failure -- that's how a handful of
  // keystrokes becomes dozens of real requests under load, not a bug in
  // the retry count itself (MAX_RETRIES is 1, confirmed in jv-gas-bridge.
  // liquid). Fix: never let more than one search be in-flight. If a newer
  // keystroke arrives while one is still pending, remember its query and
  // fire it the moment the in-flight one settles -- one in-flight request
  // at any given time, coalesced to the LATEST query, not the debounce
  // timer's original one.
  var commsSearchInFlight = false;
  var commsSearchPendingQuery = null;

  function commsSearchInput() { return document.getElementById('comms-search-input'); }
  function commsSearchResults() { return document.getElementById('comms-search-results'); }

  // Server caps search results at 25; this constant mirrors adminCrm_searchBrides.
  var COMMS_SEARCH_CAP = 25;

  function commsRenderSearchResults(rows) {
    var box = commsSearchResults();
    if (!box) return;
    if (!rows || !rows.length) {
      box.innerHTML = '<div class="comms-search-empty">No matching brides.</div>';
      box.style.display = '';
      return;
    }
    var listHtml = rows.map(function(r) {
      var meta = [];
      if (r.weddingDateLabel) meta.push(commsEscape(r.weddingDateLabel));
      if (r.email) meta.push(commsEscape(r.email));
      if (r.phone) meta.push(commsEscape(r.phone));
      var bookedBadge = r.booked ? '<span class="comms-search-result__booked">Booked</span>' : '';
      return '<div class="comms-search-result" data-email="' + commsEscape(r.email) + '" ' +
             'data-phone="' + commsEscape(r.phone || '') + '" ' +
             'data-name="' + commsEscape(r.fullName || '') + '" ' +
             'data-wedding="' + commsEscape(r.weddingDateLabel || r.weddingDateIso || '') + '">' +
             '<div class="comms-search-result__name">' + commsEscape(r.fullName || r.email) + ' ' + bookedBadge + '</div>' +
             '<div class="comms-search-result__meta">' + meta.join(' • ') + '</div>' +
             '</div>';
    }).join('');
    var footer = '';
    if (rows.length >= COMMS_SEARCH_CAP) {
      footer = '<div class="comms-search-footer">Showing first ' + COMMS_SEARCH_CAP +
               ' matches. Narrow your search to see more.</div>';
    } else {
      footer = '<div class="comms-search-footer">' + rows.length +
               (rows.length === 1 ? ' match' : ' matches') + '</div>';
    }
    box.innerHTML = listHtml + footer;
    box.style.display = '';
  }

  function commsHideSearchResults() {
    var box = commsSearchResults();
    if (box) { box.style.display = 'none'; box.innerHTML = ''; }
  }

  // D1-first bride search switch (2026-09-25), per Admin CRM's own template
  // (state/findings/HANDOFF-comms-search-d1-switch-template-2026-09-25.md,
  // Slice 1 of the Cloudflare-first migration, Consolidator's direction).
  // Same watertight, NO-GAS-FALLBACK shape as their own adminD1SearchBrides_
  // in assets/jv-admin-crm.js -- a deliberate departure from every other
  // D1-first switch on this project, which silently falls back to GAS.
  //
  // WHY NOT JUST REUSE adminD1SearchBrides_ DIRECTLY: it is defined in
  // assets/jv-admin-crm.js, which this page (sections/jv-comms.liquid) does
  // NOT load -- confirmed by grep, jv-comms.liquid only loads jv-comms.js.
  // A genuinely separate, real gap the template handoff didn't cover: this
  // page also never sets window._jvAdminProxyBase (only jv-admin-crm.liquid's
  // own inline bootstrap script does, reading shop.metafields.custom.
  // gas_team_proxy_path), so even a bare function-name copy would have
  // nothing to call against. This function is therefore a SEPARATE
  // implementation lived in THIS file until 2026-09-25, when it was extracted
  // to the shared assets/jv-admin-d1-search.js (jvAdminD1SearchBrides_ /
  // jvAdminD1SearchShowUnavailable_) so this file and jv-admin-crm.js stop
  // drifting apart (per the Consolidator's instruction, 2026-09-25 -- "1fe9ba2c
  // is taken, build the shared asset now"). This file's own proxy-base
  // bootstrap in sections/jv-comms.liquid (commit 1fe9ba2c) is unaffected --
  // the shared file reads window._jvAdminProxyBase exactly as this file's
  // local copy did.
  //
  // FLAG: COMMS_D1_SEARCH_ENABLED_ below, hardcoded false, passed into the
  // shared function on every call -- the shared file has NO flag of its own
  // (each page owns its own rollout timing, see the shared file's header
  // comment). Do NOT flip until (a) the bride-search Worker route's
  // freshness/staleness guard (handed to Cloudflare/Edge, state/findings/
  // HANDOFF-bride-search-staleness-guard-to-cloudflare-edge-2026-09-25.md) is
  // confirmed deployed, AND (b) a real jfg-identity end-to-end test against
  // commsDoSearch itself passes.
  var COMMS_D1_SEARCH_ENABLED_ = false;

  function commsDoSearch(query) {
    // Coalesce-to-latest guard (2026-09-23, see commsSearchInFlight's own
    // header comment above for the full incident this closes). If a search
    // is already in flight, remember this newer query and return WITHOUT
    // issuing a second real request -- the in-flight call's own .then/.catch
    // below fires the pending query once it settles, so no keystroke's
    // intent is ever silently dropped, it is only ever delayed until the
    // server has capacity to answer it. UNCHANGED by the D1 switch below --
    // orthogonal to which backend serves the search, per the template
    // handoff's own explicit instruction not to drop this fix.
    if (commsSearchInFlight) {
      commsSearchPendingQuery = query;
      return;
    }
    commsSearchInFlight = true;
    var seq = ++commsSearchAbortSeq;

    if (COMMS_D1_SEARCH_ENABLED_) {
      // NO GAS FALLBACK, by design (see the block comment above
      // COMMS_D1_SEARCH_ENABLED_). A D1 failure surfaces as a persistent,
      // unmissable "unavailable" state, never a silent rescue via jvBridge.
      jvAdminD1SearchBrides_(query, COMMS_D1_SEARCH_ENABLED_)
        .then(function (res) {
          if (seq !== commsSearchAbortSeq) return; // stale result
          if (res.ok) {
            commsHideStatus('comms-picker-status');
            commsRenderSearchResults(res.data);
          } else {
            jvAdminD1SearchShowUnavailable_(commsSearchResults(), res.lastReason || res.error, function () {
              commsDoSearch(query);
            });
          }
        })
        .then(function () {
          commsSearchInFlight = false;
          if (commsSearchPendingQuery !== null) {
            var next = commsSearchPendingQuery;
            commsSearchPendingQuery = null;
            commsDoSearch(next);
          }
        });
      return;
    }

    // Existing bridge_admin_searchBrides call stays here UNCHANGED as long
    // as COMMS_D1_SEARCH_ENABLED_ is false -- zero behaviour change until
    // the flag flips.
    if (typeof window.jvBridge === 'undefined' || typeof window.jvBridge.callAdmin !== 'function') {
      commsSearchInFlight = false;
      commsShowStatus('comms-picker-status', 'error', 'Backend not connected.');
      return;
    }
    // limit mirrors assets/jv-admin-crm.js's call to the same route (server caps at 25 regardless).
    jvBridge.callAdmin('bridge_admin_searchBrides', { query: query, limit: 8 })
      .then(function(res) {
        if (seq !== commsSearchAbortSeq) return; // stale result
        if (!res || !res.ok) {
          commsShowStatus('comms-picker-status', 'error', commsAuthAwareError_(res));
          commsHideSearchResults();
          return;
        }
        commsHideStatus('comms-picker-status');
        var data = res.data;
        var rows = Array.isArray(data) ? data : ((data && data.results) || []);
        commsRenderSearchResults(rows);
      })
      .catch(function(err) {
        if (seq !== commsSearchAbortSeq) return;
        commsShowStatus('comms-picker-status', 'error', 'Search failed: ' + (err && err.message ? err.message : err));
      })
      .then(function() {
        // Always runs (success, error, or stale-skip), regardless of which
        // branch above fired -- the in-flight slot must free up every time.
        commsSearchInFlight = false;
        if (commsSearchPendingQuery !== null) {
          var next = commsSearchPendingQuery;
          commsSearchPendingQuery = null;
          commsDoSearch(next);
        }
      });
  }

  /**
   * bridge_admin_searchBrides returns the literal string "Unauthorised" when
   * shopifyBridge_validateAdmin_ rejects payload.apiKey (ShopifyBridge.gs:1220).
   * That apiKey is injected transport-side by jvBridge.callAdmin() from the
   * page's ADMIN_KEY (jv-gas-bridge.liquid), which is only non-empty when the
   * logged-in customer carries the jv-admin tag AT RENDER TIME. If this page
   * was served from a cache taken before that tag existed (or before login),
   * ADMIN_KEY bakes in empty and every callAdmin() on this page silently sends
   * no key. window.jvAuth.role is set by the same tag check (jv-app-auth.liquid)
   * so a mismatch here is the fastest signal that this is a stale-render/session
   * problem, not a genuine permissions denial, surface that distinction instead
   * of the generic red banner so it's diagnosable without re-tracing the bridge.
   */
  function commsAuthAwareError_(res) {
    var raw = (res && res.error) ? String(res.error) : 'Search failed';
    if (raw === 'Unauthorised') {
      var role = (window.jvAuth && window.jvAuth.role) || 'unknown';
      if (role !== 'admin') {
        return 'Unauthorised. This page thinks you are logged in as "' + role +
          '", not admin. Refresh the page (or re-login) and try again.';
      }
      return 'Unauthorised. Your admin session key did not reach the server. ' +
        'Try a hard refresh of this page.';
    }
    return raw;
  }

  /**
   * Set the active bride: updates panel state + selected-bride chip + all
   * dependent composers (email To, SMS To, compose tab fields) and kicks off
   * the downstream loads that depend on bride context (timeline, template
   * dropdowns, social links, cowork/queue badges, Gmail triage).
   */
  function commsHasDraftInProgress_() {
    var ids = ['comms-compose-subject', 'comms-compose-body', 'comms-sms-body',
               'comms-ig-body', 'comms-fb-body', 'comms-manual-body', 'comms-manual-subject',
               'comms-ai-draft-body', 'comms-ai-instructions'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el && String(el.value || '').trim()) return true;
    }
    return false;
  }

  window.commsSetBride = function(info) {
    var panel = commsPanelRoot();
    if (!panel || !info || !info.email) return;

    var newEmail = String(info.email || '').toLowerCase();
    var currentEmail = (panel.getAttribute('data-bride-email') || '').toLowerCase();

    // Draft-in-progress guard: if switching to a different bride and there's
    // unsent content in any compose field, confirm before the To field flips.
    if (currentEmail && currentEmail !== newEmail && commsHasDraftInProgress_()) {
      var msg = 'You have an unsent draft. Switch recipient to '
                + (info.name || info.fullName || newEmail)
                + '? The To field will change but your draft text stays — '
                + 'double-check before sending.';
      if (!window.confirm(msg)) return;
    }

    panel.setAttribute('data-bride-email', newEmail);
    panel.setAttribute('data-bride-phone', String(info.phone || ''));
    panel.setAttribute('data-bride-name', String(info.name || info.fullName || ''));

    // Visible chip
    var chip = document.getElementById('comms-selected-bride');
    if (chip) {
      var nameEl = chip.querySelector('.comms-selected-bride__name');
      var metaEl = chip.querySelector('.comms-selected-bride__meta');
      if (nameEl) nameEl.textContent = info.name || info.fullName || info.email;
      var metaParts = [info.email];
      if (info.phone) metaParts.push(info.phone);
      if (info.wedding) metaParts.push(info.wedding);
      if (metaEl) metaEl.textContent = metaParts.filter(Boolean).join(' • ');
      chip.style.display = '';
    }
    var searchInput = commsSearchInput();
    if (searchInput) { searchInput.value = ''; }
    commsHideSearchResults();
    commsHideStatus('comms-picker-status');

    // Composer fields
    var toField = document.getElementById('comms-compose-to');
    if (toField) toField.value = panel.getAttribute('data-bride-email') || '';
    var smsTo = document.getElementById('comms-sms-to');
    if (smsTo) smsTo.value = panel.getAttribute('data-bride-phone') || '';

    // Reset IG/FB recipient fields before reload
    var igField = document.getElementById('comms-ig-recipient');
    if (igField) igField.value = '';
    var fbField = document.getElementById('comms-fb-recipient');
    if (fbField) fbField.value = '';

    // Downstream loads (bridge-dependent)
    if (typeof window.jvBridge !== 'undefined' && typeof window.jvBridge.callAdmin === 'function') {
      try { commsLoadTimeline(); } catch (_) {}
      try { commsTplFetchAll(null); } catch (_) {}
      try { commsLoadTriageSummary(); } catch (_) {}
      try { commsRefreshCoworkBadge(); } catch (_) {}
      try { commsQueueRefreshBadge(); } catch (_) {}
      try { commsLoadMetaRecipient('ig_dm'); } catch (_) {}
      try { commsLoadMetaRecipient('fb_dm'); } catch (_) {}
    }
  };

  window.commsClearBride = function() {
    var panel = commsPanelRoot();
    if (panel) {
      panel.setAttribute('data-bride-email', '');
      panel.setAttribute('data-bride-phone', '');
      panel.setAttribute('data-bride-name', '');
    }
    var chip = document.getElementById('comms-selected-bride');
    if (chip) chip.style.display = 'none';
    var toField = document.getElementById('comms-compose-to');
    if (toField) toField.value = '';
    var smsTo = document.getElementById('comms-sms-to');
    if (smsTo) smsTo.value = '';
    var timeline = document.getElementById('comms-timeline');
    if (timeline) {
      timeline.innerHTML = '<div class="comms-empty">Select a recipient to load their communications.</div>';
    }
    var input = commsSearchInput();
    if (input) { input.value = ''; input.focus(); }
    commsHideSearchResults();
  };

  function commsWirePicker() {
    var input = commsSearchInput();
    if (!input) return;
    input.addEventListener('input', function() {
      var q = input.value.trim();
      if (commsSearchDebounce) clearTimeout(commsSearchDebounce);
      if (q.length < 2) {
        commsHideSearchResults();
        return;
      }
      commsSearchDebounce = setTimeout(function() { commsDoSearch(q); }, 220);
    });
    input.addEventListener('focus', function() {
      var box = commsSearchResults();
      if (box && box.innerHTML) box.style.display = '';
    });
    // Delegate click on result rows
    var box = commsSearchResults();
    if (box) {
      box.addEventListener('mousedown', function(e) {
        var row = e.target.closest('.comms-search-result');
        if (!row) return;
        e.preventDefault(); // avoid blur-before-click race
        commsSetBride({
          email:    row.getAttribute('data-email') || '',
          phone:    row.getAttribute('data-phone') || '',
          name:     row.getAttribute('data-name') || '',
          fullName: row.getAttribute('data-name') || '',
          wedding:  row.getAttribute('data-wedding') || ''
        });
      });
    }
    // Dismiss results on outside click
    document.addEventListener('mousedown', function(e) {
      var picker = document.getElementById('comms-picker');
      if (picker && !picker.contains(e.target)) commsHideSearchResults();
    });
  }

  function commsReadEmailFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search);
      // 'bride' is the param every Admin Bride Profile link uses (three call
      // sites in assets/jv-admin-bride-profile-v2.js). Missing it here landed
      // every profile click-through on an empty Recipient field, no error shown
      // (found 2026-08-05, BRIEFS/HANDOFF-comms-deeplink-bride-param-to-comms-
      // agent-2026-08-05.md). Aliasing here covers all callers at once. Verified
      // no other meaning for 'bride' as a query param in comms before adding it.
      // The value is still never trusted directly - see the exact-match guard below.
      var email = (p.get('email') || p.get('brideEmail') || p.get('bride') || '').trim();
      return email ? email.toLowerCase() : '';
    } catch (_) { return ''; }
  }

  // ── Init: pre-fill compose To field if panel already has email ─────────────
  (function init() {
    var toField = document.getElementById('comms-compose-to');
    if (toField) toField.value = commsBrideEmail();
    // Pre-fill SMS To from data-bride-phone attribute
    var smsTo = document.getElementById('comms-sms-to');
    if (smsTo) smsTo.value = (commsPanelRoot().getAttribute('data-bride-phone') || '');

    commsWirePicker();

    // Bridge-dependent calls: only run if jvBridge is available
    if (typeof window.jvBridge !== 'undefined' && typeof window.jvBridge.callAdmin === 'function') {
      // Deep link: ?email=bride@example.com auto-selects that bride ONLY if
      // the email is an exact match against a CRM row returned by search.
      // Never trust the URL value directly — a hand-crafted URL could
      // otherwise prime the panel with an arbitrary recipient.
      var deepEmail = commsReadEmailFromUrl();
      if (deepEmail) {
        // limit mirrors assets/jv-admin-crm.js's call to the same route (server caps at 25 regardless).
        jvBridge.callAdmin('bridge_admin_searchBrides', { query: deepEmail, limit: 8 })
          .then(function(res) {
            if (!res || !res.ok) {
              // Was previously silent (fixed 2026-08-04, BRIEFS/FIX-comms-search-
              // unauthorised-2026-08-04.md) - a failed deep-link resolve left the
              // page looking normal with no recipient ever selected.
              commsShowStatus('comms-picker-status', 'error', commsAuthAwareError_(res));
              return;
            }
            var data = res.data;
            var rows = Array.isArray(data) ? data : ((data && data.results) || []);
            var hit = null;
            for (var i = 0; i < rows.length; i++) {
              if ((rows[i].email || '').toLowerCase() === deepEmail) { hit = rows[i]; break; }
            }
            if (hit) {
              commsSetBride({
                email: hit.email, phone: hit.phone, name: hit.fullName,
                fullName: hit.fullName, wedding: hit.weddingDateLabel || hit.weddingDateIso
              });
            } else {
              // Do NOT name a URL param here. The link may have used ?email=,
              // ?brideEmail= or ?bride= (all aliased in commsReadEmailFromUrl),
              // and quoting the wrong one sends the admin looking at an address
              // bar that says something else.
              //
              // Wording is deliberately "could not be found" rather than "does
              // not exist": as of 2026-08-10 a real, findable bride can miss
              // here through no fault of the URL. adminCrm_getCachedSearchIndex_
              // caches a TRUNCATED copy of the search index but returns the full
              // one on a cache miss, so on a cache HIT (5-min TTL) any bride
              // ranked below the cut is invisible to search. The ranking puts
              // unbooked leads and furthest-out weddings in the discarded tail.
              // See BRIEFS/RESULTS-comms-deeplink-search-miss-2026-08-10.md,
              // the fix is in AdminCRMAPI.gs and belongs to the Admin CRM lane.
              commsShowStatus('comms-picker-status', 'warn',
                'Could not find ' + deepEmail + ' in the CRM search. ' +
                'Try the search above. If she is a lead or her wedding is far ' +
                'off, search may not have her indexed right now.');
            }
          })
          .catch(function(err) {
            commsShowStatus('comms-picker-status', 'error',
              'Deep-link lookup failed: ' + (err && err.message ? err.message : err));
          });
      }

      // Always-on background loads (do not require a selected bride)
      commsRefreshCoworkBadge();
      commsTplFetchAll(null);
      commsLoadTriageSummary();
      commsQueueRefreshBadge();
    }
  })();

  // F3c: Default to SMS channel when running inside FluxBuilder WebView
  (function commsDefaultSmsInApp_() {
    if (!document.documentElement.classList.contains("jv-in-app")) return;
    var smsChannelBtn = document.getElementById('comms-ch-sms-btn');
    if (smsChannelBtn) smsChannelBtn.click();
  })();

  // ── Inject "Also send SMS" toggle into email compose area ─────────────────
  // jv-comms.liquid is frozen, so we inject the toggle via JS after the page loads.
  (function commsInjectSmsToggle_() {
    var STATUS_POLL_LIMIT = 20;
    var polls = 0;
    var interval = setInterval(function() {
      var statusEl = document.getElementById('comms-compose-status');
      if (!statusEl) {
        if (++polls >= STATUS_POLL_LIMIT) clearInterval(interval);
        return;
      }
      clearInterval(interval);

      var smsToggleHtml =
        '<div id="comms-compose-sms-toggle" style="margin-top:14px;padding-top:14px;border-top:1px solid #f0ebe8;">'
        + '<label style="display:flex;align-items:center;gap:10px;cursor:pointer;font-size:13px;color:var(--brand-text,#2f2524);">'
        +   '<input type="checkbox" id="comms-compose-also-sms" style="width:15px;height:15px;accent-color:var(--brand-primary,#c99591);">'
        +   'Also send SMS to bride'
        + '</label>'
        + '<div id="comms-compose-sms-box" style="display:none;margin-top:10px;">'
        +   '<div id="comms-compose-phone-display" style="font-size:12px;color:#9a918a;margin-bottom:6px;"></div>'
        +   '<textarea id="comms-compose-sms-body" rows="3" placeholder="SMS message..." '
        +     'style="width:100%;box-sizing:border-box;border:1px solid #e6dad4;border-radius:var(--radius-medium,1rem);padding:10px;font-size:13px;font-family:inherit;resize:vertical;"></textarea>'
        + '</div>'
        + '</div>';

      statusEl.insertAdjacentHTML('beforebegin', smsToggleHtml);

      document.getElementById('comms-compose-also-sms').addEventListener('change', function() {
        var box      = document.getElementById('comms-compose-sms-box');
        var phoneEl  = document.getElementById('comms-compose-phone-display');
        var bodyEl   = document.getElementById('comms-compose-sms-body');
        var phone    = commsPanelRoot().getAttribute('data-bride-phone') || '';
        box.style.display = this.checked ? '' : 'none';
        if (this.checked) {
          phoneEl.textContent = phone ? 'Sending to: ' + phone : 'No phone on file — SMS will not be sent.';
          if (!bodyEl.value.trim()) {
            var emailBody = (document.getElementById('comms-compose-body') || {}).value || '';
            bodyEl.value = emailBody.replace(/<[^>]+>/g, '').trim().substring(0, 160);
          }
        }
      });
    }, 150);
  })();

  /** Lightweight badge refresh for queue tab -- does not render full queue. */
  function commsQueueRefreshBadge() {
    var handle = function(result) {
      result = window.jvUnwrap ? window.jvUnwrap(result) : ((result && result.data) || result);
      if (!result) return;
      var totalPending = (result.needs_draft || 0) + (result.needs_review || 0) + (result.approved || 0);
      var badge = document.getElementById('comms-queue-badge');
      if (badge) {
        if (totalPending > 0) { badge.textContent = totalPending; badge.style.display = ''; }
        else { badge.style.display = 'none'; }
      }
    };

    if (COMMS_D1_READS_ENABLED_ || COMMS_D1_READS_APPROVALQUEUE_ENABLED_) {
      commsD1ProxyCall_('drafts', { view: 'approval_queue' }).then(function(result) {
        if (result && result.ok === false) {
          commsQueueRefreshBadgeViaGas_(handle);
          return;
        }
        handle(result);
      }).catch(function() {
        commsQueueRefreshBadgeViaGas_(handle);
      });
      return;
    }

    commsQueueRefreshBadgeViaGas_(handle);
  }

  function commsQueueRefreshBadgeViaGas_(handle) {
    jvBridge.callAdmin('comms_getApprovalQueue', {})
      .then(handle)
      .catch(function() { /* silent -- matches this read's pre-existing posture: a badge count is non-critical, never surface an error banner for it */ });
  }

})();
